function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaiting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M669.85,129.64H543.21V43H669.85Zm-125.64-1H668.85V44H544.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.11,48.58a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,553.11,48.58Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.4,48.58a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,563.4,48.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.69,48.58a2.52,2.52,0,1,1-2.52-2.52A2.51,2.51,0,0,1,573.69,48.58Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 543.71,
    y: 53.02,
    width: 125.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.36,84.6a3.16,3.16,0,0,1,3.3,0l.85.49.88.44a3.16,3.16,0,0,1,1.84,2.73l.13,4.06,13.23-.41-.13-4.06A3.18,3.18,0,0,1,101.13,85a19.22,19.22,0,0,0,1.67-1,3.15,3.15,0,0,1,3.29-.21l3.57,1.91L115.92,74l-3.57-1.91a3.14,3.14,0,0,1-1.64-2.86,18.44,18.44,0,0,0-.07-2,3.15,3.15,0,0,1,1.46-3l3.45-2.15-7-11.25-3.47,2.15a3.12,3.12,0,0,1-3.28,0c-.28-.17-.56-.33-.85-.48s-.58-.3-.87-.44a3.17,3.17,0,0,1-1.85-2.74l-.12-4.07-13.23.41L85,49.77a3.14,3.14,0,0,1-1.65,2.86,19.66,19.66,0,0,0-1.69,1,3.13,3.13,0,0,1-3.29.21L74.82,52,68.56,63.64l3.57,1.92a3.16,3.16,0,0,1,1.65,2.85,16.25,16.25,0,0,0,.06,2,3.14,3.14,0,0,1-1.46,3l-3.45,2.14,7,11.25Zm3.32-20.9a10.84,10.84,0,1,1,4.44,14.68A10.85,10.85,0,0,1,82.68,63.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.24,330.54a2.19,2.19,0,0,1,2-1.08l.69,0,.68,0a2.19,2.19,0,0,1,2,1.07l1.43,2.47,8-4.63-1.42-2.47a2.19,2.19,0,0,1,.08-2.31q.38-.58.69-1.2a2.21,2.21,0,0,1,2-1.22h2.84V311.9h-2.84a2.21,2.21,0,0,1-2-1.22q-.32-.62-.69-1.2a2.19,2.19,0,0,1-.08-2.31l1.42-2.47-8-4.63-1.43,2.47a2.22,2.22,0,0,1-2,1.08l-.68,0-.69,0a2.21,2.21,0,0,1-2-1.08l-1.42-2.47-8,4.63,1.42,2.46a2.19,2.19,0,0,1-.08,2.31,13,13,0,0,0-.69,1.21,2.21,2.21,0,0,1-2,1.22h-2.84v9.27h2.84a2.21,2.21,0,0,1,2,1.22,11.7,11.7,0,0,0,.69,1.2,2.21,2.21,0,0,1,.08,2.32l-1.42,2.46,8,4.63Zm-4.88-14a7.6,7.6,0,1,1,7.61,7.59A7.61,7.61,0,0,1,669.36,316.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.25,96.3a2.23,2.23,0,0,1,1.08,2c0,.23,0,.45,0,.68s0,.46,0,.69a2.21,2.21,0,0,1-1.08,2l-2.47,1.42,4.64,8,2.47-1.42a2.19,2.19,0,0,1,2.31.08,12.71,12.71,0,0,0,1.19.69,2.21,2.21,0,0,1,1.22,2v2.84h9.28v-2.84a2.21,2.21,0,0,1,1.22-2,12.71,12.71,0,0,0,1.19-.69,2.21,2.21,0,0,1,2.32-.08l2.46,1.42,4.64-8-2.48-1.43a2.17,2.17,0,0,1-1.07-2c0-.23,0-.46,0-.69s0-.45,0-.68a2.2,2.2,0,0,1,1.08-2l2.47-1.42-4.64-8-2.46,1.42a2.19,2.19,0,0,1-2.31-.08q-.59-.37-1.2-.69a2.21,2.21,0,0,1-1.22-2V82.7h-9.28v2.84a2.21,2.21,0,0,1-1.22,2q-.61.31-1.2.69a2.19,2.19,0,0,1-2.31.08l-2.46-1.42-4.64,8Zm14-4.87a7.6,7.6,0,1,1-7.6,7.6A7.61,7.61,0,0,1,133.25,91.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "665.66 305.52 593.09 294.07 607.79 200.91 661.68 209.41 677.57 230.11 665.66 305.52",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.68 209.41 677.57 230.11 658.88 227.16 661.68 209.41",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.17,281,633,277.49l-24.35-3.65-.4-.06.06-.41,6.14-39.64.07-.5.5.08c16.14,2.58,32.29,5.09,48.42,7.75l.35.05,0,.35-3.28,19.88Zm0,0,2.92-19.93L663,241.35l.3.41c-16.17-2.42-32.31-5-48.47-7.46l.57-.42-6.31,39.62-.34-.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.39,243.71c4.07.43,8.12,1,12.17,1.52s8.09,1.2,12.13,1.79,8.07,1.3,12.1,2l6,1.08c2,.4,4,.77,6,1.2-2-.21-4.06-.48-6.1-.71l-6.07-.81c-4-.56-8.09-1.2-12.13-1.79s-8.07-1.3-12.09-2S617.4,244.55,613.39,243.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.17,237.61c-.31,3.33-.74,6.65-1.18,10s-.93,6.63-1.44,9.93-1.06,6.6-1.66,9.89l-.92,4.93c-.34,1.64-.65,3.29-1,4.92.15-1.67.36-3.33.54-5l.64-5c.42-3.32.93-6.62,1.44-9.93s1.06-6.6,1.67-9.89S638.45,240.88,639.17,237.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.84,253.62c4.07.43,8.12,1,12.17,1.52s8.08,1.2,12.13,1.79,8.07,1.3,12.09,2l6,1.09c2,.4,4,.77,6,1.19-2-.2-4.06-.47-6.09-.7l-6.08-.82c-4.05-.55-8.08-1.19-12.13-1.78s-8.07-1.31-12.09-2S615.84,254.46,611.84,253.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.28,263.53c4.07.43,8.12,1,12.17,1.52s8.09,1.19,12.13,1.79,8.07,1.3,12.1,2l6,1.09c2,.4,4,.76,6,1.19-2-.2-4.07-.47-6.1-.71l-6.07-.81c-4-.55-8.09-1.19-12.13-1.79s-8.07-1.3-12.1-2S614.29,264.37,610.28,263.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.97 168.23 90.38 198.86 51.06 127.5 92.34 104.75 114.15 110.47 145.97 168.23",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.34 104.75 114.15 110.47 99.83 118.35 92.34 104.75",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.21,156l-18.34,10.4L90.32,176.86l-.36.2-.2-.36L72.94,146.4l-.25-.44.44-.24c12.39-6.78,24.74-13.63,37.16-20.35l.31-.17.17.31,8.28,15.32Zm0,0-8.59-15.14-8.47-15,.48.14c-12.3,6.93-24.68,13.73-37,20.6l.2-.68L90.48,176.3l-.56-.16,18.54-10Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.56,153.74c3-1.89,6-3.68,9.09-5.45s6.13-3.51,9.21-5.22,6.2-3.39,9.33-5l4.7-2.44c1.59-.78,3.16-1.59,4.76-2.34-1.49.95-3,1.85-4.52,2.77l-4.57,2.68c-3,1.79-6.13,3.51-9.21,5.22s-6.2,3.39-9.33,5S80.75,152.22,77.56,153.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.92,135.92c1.57,2.43,3,4.91,4.52,7.4s2.88,5,4.29,7.53,2.77,5.07,4.09,7.64l2,3.86c.62,1.3,1.28,2.59,1.88,3.91-.8-1.21-1.54-2.45-2.31-3.67l-2.22-3.73c-1.47-2.48-2.88-5-4.29-7.53s-2.77-5.07-4.08-7.64S93.13,138.55,91.92,135.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.75,161.33c3-1.89,6-3.68,9.08-5.46s6.14-3.5,9.22-5.22,6.19-3.39,9.33-5l4.7-2.43c1.59-.78,3.16-1.59,4.76-2.35-1.5,1-3,1.85-4.52,2.78l-4.57,2.68c-3,1.78-6.13,3.5-9.22,5.22s-6.19,3.39-9.33,5S84.94,159.8,81.75,161.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.93,168.91c3-1.88,6-3.68,9.09-5.45s6.13-3.51,9.22-5.22,6.19-3.39,9.32-5l4.71-2.44c1.58-.78,3.15-1.59,4.75-2.34-1.49.95-3,1.85-4.51,2.77l-4.57,2.68c-3,1.79-6.13,3.51-9.22,5.22s-6.19,3.39-9.33,5S89.13,167.39,85.93,168.91Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.2,248.71c-3.8-3.72-8.71-8.22-14.52-6.62-5.46,1.51-7.55,7.48-8.53,12.44-1.26,6.41-2.24,12.88-3.26,19.32s-2,13-2.93,19.56q-.79,5.52-1.56,11c-.26,1.84-.52,3.69-.77,5.53s-.56,3.61-.65,5.43c0,.58.88.67,1,.11.71-3.07,1-6.26,1.45-9.38s.91-6.27,1.36-9.41c.91-6.23,1.86-12.45,2.79-18.67s1.91-12.45,2.91-18.67c.84-5.27,1.24-11.83,5.91-15.3a9,9,0,0,1,8.75-.82c3.07,1.17,5.53,3.37,7.94,5.55A.08.08,0,0,0,140.2,248.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,244.9s-7.77-2.79-11.6,2.88.75,20.07,36.1,28.21a99.72,99.72,0,0,0-8.5-32C143.42,227.5,129.91,233.76,135,244.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.47,273.63a27.4,27.4,0,0,0-1.78-2.87c-.59-.91-1.19-1.82-1.79-2.72-.45-.68-.92-1.35-1.38-2,0-.16,0-.33.06-.5l.12-.92c.09-.66.19-1.32.28-2s.21-1.32.34-2a10.44,10.44,0,0,1,.46-2.08c0-.1-.14-.15-.15,0a8.12,8.12,0,0,1-.32,1.17l-.24.89c-.17.67-.33,1.35-.48,2s-.26,1.25-.37,1.88c-.05.3-.09.6-.13.9-.63-.89-1.28-1.78-1.94-2.66-1.88-2.47-3.86-4.85-5.92-7.17a.15.15,0,0,0,0-.07c.19-3.71.1-7.39.92-11,0-.1-.12-.16-.15-.06A38.16,38.16,0,0,0,143.71,255c-.73-.82-1.48-1.64-2.23-2.45q-2.58-2.77-5.27-5.46c-.07-.07-.19,0-.12.11,3,3.21,5.81,6.55,8.57,10a60.74,60.74,0,0,0-6.47.24c-2.39.18-4.77.48-7.15.81a.08.08,0,1,0,0,.16,65.52,65.52,0,0,1,7.14-.64c2.31-.1,4.6,0,6.91,0,1.49,1.85,3,3.7,4.41,5.58h-1.95c-1.08,0-2.15.1-3.22.19a47.85,47.85,0,0,0-6.53,1,.08.08,0,0,0,0,.15c2.17-.24,4.35-.45,6.53-.52,1.05,0,2.09,0,3.13,0h1.63a1.87,1.87,0,0,0,.89-.08c1,1.24,1.9,2.47,2.84,3.71.75,1,1.49,2,2.22,3s1.42,2.15,2.24,3.11A.08.08,0,0,0,157.47,273.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38,252.93a23.88,23.88,0,0,0-3.78-.18c-1.26,0-2.53,0-3.79.08a.08.08,0,1,0,0,.16c1.28-.09,2.56-.12,3.84-.1s2.48.14,3.71.11A0,0,0,0,0,138.38,252.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,255.78c.14-1.2.29-2.42.55-3.61a.08.08,0,1,0-.16,0c-.18,1.19-.41,2.37-.58,3.56-.09.59-.17,1.19-.25,1.79a8.6,8.6,0,0,0-.14,1.68.11.11,0,0,0,.21,0,10.53,10.53,0,0,0,.18-1.68C149.34,256.93,149.41,256.36,149.48,255.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15,242.41c-.31,1.17-.62,2.36-.83,3.56-.11.6-.21,1.21-.29,1.82a7.71,7.71,0,0,0-.12,1.79.05.05,0,0,0,.1,0,9.82,9.82,0,0,0,.27-1.71c.08-.58.17-1.17.27-1.75.22-1.24.44-2.46.75-3.67A.08.08,0,0,0,147.15,242.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.12,314.11c-.2-2.23-.42-4.45-.65-6.68-.46-4.4-1-8.79-1.59-13.18s-1.15-8.76-1.86-13.12a32,32,0,0,0-1.35-6,5.63,5.63,0,0,0-3.3-3.72c-4.16-1.44-7,2.87-8.64,5.93,0,.09.08.15.14.07,1-1.44,3.78-5.5,6.94-5.31,2.12.13,3.82,1.63,4.84,6.92,2.54,13.19,4.83,40,5.09,41.71.15.93.8.89.81-.1C101.56,318.48,101.31,316.29,101.12,314.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.85,275.73s3.64-12.83-4.4-6.41C67.07,280,66.6,303.24,66.6,303.24s23.78-13.81,26.73-22.92C97.74,266.75,84.85,275.73,84.85,275.73Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.35,282c-1.86.37-3.76.62-5.64.89l-2.68.38c-.6.08-1.21.14-1.82.21,1.77-2.44,3.56-4.87,5.26-7.36.06-.09-.08-.19-.16-.11a54.3,54.3,0,0,0-4,4.58c-.35-1-.71-2-1.06-3s-.84-2.29-1.13-3.47a.08.08,0,0,0-.15,0c.32,1.18.55,2.38.87,3.56s.65,2.26,1,3.37c-.87,1.13-1.71,2.29-2.52,3.46-.41-1.16-.92-2.28-1.27-3.46a.08.08,0,0,0-.16.05c.43,1.3.66,2.65,1.06,4-.55.8-1.09,1.6-1.61,2.4-1,1.49-1.87,3-2.75,4.52a.35.35,0,0,0-.21.36c-1.5,2.6-2.93,5.24-4.34,7.9a.08.08,0,1,0,.14.07c1.41-2.62,3-5.18,4.61-7.7h0a4.32,4.32,0,0,1,.78-.15l.82-.18c.61-.13,1.22-.29,1.83-.44,1.21-.3,2.4-.58,3.63-.8.1,0,0-.17,0-.15-1.44.27-2.88.44-4.34.61-.69.08-1.37.16-2,.27l-.1,0q1.28-2,2.6-3.87c.86-1.25,1.75-2.49,2.64-3.72.83-.12,1.64-.33,2.46-.49l2.76-.54c1.84-.36,3.68-.77,5.53-1.08C89.5,282.17,89.45,282,89.35,282Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.06,283.3c-.11-.34-.21-.68-.32-1a19.92,19.92,0,0,1-.55-2.15c0-.1-.17-.06-.15,0,.16.73.33,1.45.49,2.17a14.54,14.54,0,0,0,.62,2.14.15.15,0,0,0,.28-.09C75.32,284,75.18,283.67,75.06,283.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.78,279.06c-1.08.17-2.17.24-3.27.34s-2.17.25-3.26.41c-.06,0-.06.1,0,.1,1.09-.08,2.18-.16,3.27-.31s2.17-.3,3.27-.38C91.89,279.22,91.88,279.05,91.78,279.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.62,297.85c-.43-9.45-1-18.88-2-28.3-.47-4.69-1-9.37-1.66-14a98,98,0,0,0-2.71-13.58,26,26,0,0,0-4.52-9.58,10.24,10.24,0,0,0-9.14-4c-4.13.51-7.47,3.11-10.35,5.95-3.23,3.17-6.19,6.64-9.18,10-.76.86-1.51,1.72-2.26,2.59-.06.08.05.19.12.11,2.93-3.36,6-6.63,9.15-9.75,2.94-2.89,6-6,10-7.23a10.28,10.28,0,0,1,5.84-.14,9.25,9.25,0,0,1,4,2.52c2.3,2.39,3.58,5.62,4.5,8.74,2.54,8.69,3.45,17.8,4.39,26.77,1,9.12,1.61,18.26,2.07,27.41s.82,18.42,1.71,27.59c.11,1.13.25,2.26.4,3.39.09.76,1.27.76,1.21,0C119.48,316.84,119,307.35,118.62,297.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.74,235.33s5.4-10-1-13.19S59,242.76,52.81,277.6c0,0,34.47-15.26,46.18-30.45S97.42,228.6,87.74,235.33Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81,243.45c-3.87,0-7.74-.29-11.61-.26.72-.84,1.45-1.67,2.18-2.5a34.93,34.93,0,0,0,3-3.52c0-.08-.06-.19-.14-.13A27.11,27.11,0,0,0,83.34,240c-1,1-1.94,2.07-2.9,3.11-1.48,1.6-2.93,3.23-4.38,4.86,0-.16,0-.32,0-.47,0-.68,0-1.36,0-2,0-1.31,0-2.62,0-3.94,0-2.66,0-5.34.2-8,0-.1-.15-.1-.16,0-.18,2.67-.46,5.33-.59,8-.06,1.31-.09,2.62-.11,3.94,0,.68,0,1.36,0,2,0,.36,0,.76,0,1.14-.22.25-.46.5-.68.76-3.09,3.53-6,7.18-8.9,10.9,0-.2,0-.41,0-.61,0-.41-.09-.82-.13-1.23-.1-.89-.22-1.78-.36-2.66s-.25-1.66-.39-2.49-.39-1.88-.46-2.82a.08.08,0,1,0-.15,0,26.92,26.92,0,0,1,.32,2.83l.24,2.56c.07.86.15,1.71.24,2.56l.12,1.23c0,.21.05.41.07.62a1.12,1.12,0,0,0,.17.48c-.49.64-1,1.28-1.47,1.93-2,2.58-3.88,5.2-5.8,7.81-.06.08.06.2.12.11,1.82-2.37,3.69-4.69,5.58-7,1.42.06,2.87,0,4.29-.07s3,0,4.48,0c.1,0,.1-.17,0-.16l-4.49.05c-1.36,0-2.75-.06-4.11,0,1.66-2,3.35-4,5-6,.61-.74,1.23-1.47,1.85-2.2a8.33,8.33,0,0,0,1.73.06h2l3.82-.06c2.63,0,5.26-.13,7.89-.13a.08.08,0,0,0,0-.16c-2.64,0-5.27-.15-7.9-.21-1.28,0-2.55-.08-3.83-.1l-2,0c-.38,0-.78,0-1.18,0l4.35-5.14a.21.21,0,0,0,.08-.1c1.41-1.66,2.82-3.33,4.25-5,.2-.23.4-.45.59-.68,4,.13,8-.14,12-.06C92.92,243.61,92.92,243.45,92.81,243.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.83,250.3h-.94a.07.07,0,1,0,0,.14h.93A.08.08,0,0,0,90.83,250.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.74,250.31c-1.24,0-2.48,0-3.72-.07l-1.86-.06a6.67,6.67,0,0,0-1.73,0c-.06,0-.05.1,0,.11a6.74,6.74,0,0,0,1.74.12l1.86,0c1.24,0,2.48,0,3.72,0C88.85,250.47,88.85,250.32,88.74,250.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.91,262a51.4,51.4,0,0,0-7.63-.69s0,.05,0,.06c2.54.24,5.07.37,7.59.78C78,262.12,78,262,77.91,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.54,250.86c0-.22-.05-.45-.08-.67-.06-.5-.14-1-.22-1.49-.15-.95-.31-1.89-.49-2.83,0-.09-.17-.07-.16,0,.12,1,.23,2,.32,2.93l.12,1.44a4.11,4.11,0,0,0,.19,1.36.19.19,0,0,0,.34-.05A1.89,1.89,0,0,0,67.54,250.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.28,222.5c-1.24-2.3-2.81-5.33-5.89-5.14-2.54.16-3.69,2.76-4.23,4.9-1.68,6.64-1.8,13.63-2.12,20.43-.7,14.37-1.32,28.76-1.41,43.14q0,6,0,12c0,4.06,0,8.16.28,12.22a.3.3,0,0,0,.6,0c0-3.48-.1-7-.11-10.44s0-6.79.06-10.18q.17-10.32.55-20.63c.26-6.83.56-13.66.85-20.49q.21-5.12.44-10.24c.15-3.3.29-6.61.67-9.9.21-1.84.48-3.69.87-5.5a7.69,7.69,0,0,1,1.59-3.69,3.47,3.47,0,0,1,4.49-.32,9.48,9.48,0,0,1,3.19,4C118.19,222.68,118.33,222.59,118.28,222.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.44,221.4s-2.53-8.94,3.07-4.47c9.32,7.45,9.65,23.64,9.65,23.64s-16.57-9.63-18.63-16C108.46,215.14,117.44,221.4,117.44,221.4Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,233.93c-.15-.25-.31-.49-.47-.73a5,5,0,0,0,0-.77c0-.38,0-.77,0-1.15,0-.76,0-1.51.08-2.27,0-.1-.16-.09-.16,0q-.06,1.11-.09,2.22c0,.37,0,.74,0,1.11,0,.15,0,.31,0,.48-.65-1-1.32-2-2-3-.2-.29-.41-.56-.61-.85a15.82,15.82,0,0,1,0-2.92c0-1,0-2.07.06-3.11a.08.08,0,0,0-.16,0c0,1.08-.08,2.16-.14,3.24a19.86,19.86,0,0,0-.06,2.31c-1.6-2.17-3.3-4.27-5-6.35,0-.07-.18,0-.12.1,1.06,1.34,2.08,2.72,3.08,4.12-2-.45-3.93-.72-5.91-1-.1,0-.14.14,0,.15,2.1.32,4.16.85,6.23,1.3h0c.79,1.11,1.58,2.24,2.35,3.36.32.46.63.93.94,1.39h-.08c-.22,0-.43-.07-.65-.09-.46-.06-.92-.09-1.38-.13-1-.08-1.91-.13-2.87-.18-.1,0-.09.16,0,.16.94,0,1.88.1,2.81.2.5.05,1,.12,1.49.18l.64.07.19,0c.53.78,1.07,1.56,1.59,2.35.94,1.38,1.78,2.86,2.77,4.2a.08.08,0,0,0,.13-.08A41,41,0,0,0,126.67,233.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.55,223.83c0-.35,0-.7,0-1.05a16.11,16.11,0,0,1,.09-2.19.08.08,0,1,0-.15,0c0,.72-.08,1.44-.12,2.17,0,.36,0,.72,0,1.08v.5a1.8,1.8,0,0,0,0,.52.07.07,0,0,0,.14,0,1.54,1.54,0,0,0,0-.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5,227.53c-.62-.1-1.25-.14-1.87-.19s-1.36-.12-2-.2a.08.08,0,1,0,0,.15c1.31.09,2.61.32,3.92.37C120.56,227.66,120.57,227.54,120.5,227.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.7,227.59c0,.06,0,.26,0,.34v.91c0,.21,0,.42,0,.63a1.44,1.44,0,0,0,0,.55,0,0,0,0,0,.06,0,.59.59,0,0,0,0-.26c0-.1,0-.2,0-.29v-.63c0-.21,0-.41,0-.62v-.29c0-.09,0-.27,0-.35S125.6,227.44,125.7,227.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.66,270.21c-3.48-2.61-6.61-6.37-11.3-6.55-3.87-.16-6.58,2.76-8.13,6A34.55,34.55,0,0,0,97.34,275q-1.05,3.67-2,7.38c-1.21,4.85-2.25,9.76-3.1,14.69-.47,2.75-.91,5.52-1.26,8.29a70.93,70.93,0,0,0-.81,8.48.44.44,0,0,0,.87.09c.47-2.32.67-4.71,1-7.05s.7-4.71,1.09-7.05c.8-4.69,1.72-9.37,2.78-14,1-4.38,2-8.83,3.39-13.1,1-3.06,2.64-6.63,6-7.73,5-1.68,9.59,2.58,13.27,5.34C118.63,270.39,118.74,270.28,118.66,270.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.06,267.71s-3.21-9.17,1.43-11c7-2.69,25.18,17.83,21.61,49.27,0,0-14.07-7.75-24.47-16.48s-13-20.11-8.47-23.06S115.06,267.71,115.06,267.71Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,299.27a24.74,24.74,0,0,0-1.69-3.17c-.6-1.07-1.2-2.15-1.82-3.21-1.21-2.07-2.41-4.14-3.65-6.19-.2-.34-.41-.66-.61-1,0-.12.05-.24.07-.36l.21-.91c.16-.69.28-1.38.4-2.06.26-1.35.49-2.71.85-4,0-.1-.13-.13-.15,0-.29,1.34-.72,2.67-1.11,4-.2.65-.41,1.3-.58,1.95l-.18.68c-1.49-2.46-3-4.9-4.66-7.26a3.29,3.29,0,0,0,.17-1c0-.46.1-.92.16-1.37.12-1,.24-2.07.39-3.1.3-2,.6-4,1.1-6,0-.1-.13-.13-.16,0-.5,2-1,4-1.42,6-.18,1-.36,2-.49,3-.06.49-.12,1-.17,1.49,0,.15,0,.3-.06.45-.5-.71-1-1.42-1.53-2.12-1.61-2.11-3.28-4.18-5-6.24-.06-.08-.2,0-.13.09a112.61,112.61,0,0,1,7.92,11.57c.46.73.91,1.48,1.37,2.22l-.46-.06c-.59-.07-1.18-.11-1.77-.16-1.19-.12-2.37-.22-3.56-.31-2.37-.19-4.75-.34-7.11-.59a.08.08,0,0,0,0,.16c2.4.27,4.78.66,7.17,1L123,283a14.06,14.06,0,0,0,2.71.28c.93,1.51,1.87,3,2.8,4.54-.21,0-.43,0-.63,0h-3.39c-1.53,0-3.06,0-4.58,0-.11,0-.09.16,0,.16,1.55,0,3.09.1,4.64.18.73,0,1.46.08,2.2.13l1.1.08a2.21,2.21,0,0,0,1,0l2.38,3.86c.73,1.19,1.47,2.38,2.22,3.55a28.23,28.23,0,0,0,2.39,3.58C135.91,299.42,136,299.37,136,299.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.29,273.86a21.76,21.76,0,0,1-.63,3c-.26,1-.55,2-.88,3,0,.13.14.19.19.06.31-1,.59-2,.83-3s.4-2,.65-3.05C129.47,273.79,129.3,273.76,129.29,273.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,280a1.18,1.18,0,0,0-.77-.28l-1.33-.19c-.82-.11-1.65-.2-2.47-.3-1.72-.2-3.43-.36-5.15-.58a.08.08,0,0,0,0,.16c1.62.19,3.23.44,4.85.65.79.1,1.58.22,2.37.31l1.15.13a3.78,3.78,0,0,1,1.3.22A.07.07,0,0,0,119,280Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.27,293.83c-.81-.07-1.63-.1-2.44-.12l-1.23,0-.59,0a3.29,3.29,0,0,1-.77,0c-.11,0-.12.18,0,.16a3.47,3.47,0,0,1,.72,0l.64,0,1.22.07c.81.05,1.63.1,2.44.1A.09.09,0,0,0,129.27,293.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.23,290.31l.27-1.38c.16-.91.33-1.81.5-2.72a.08.08,0,0,0-.16,0l-.6,2.65c-.1.44-.2.88-.29,1.33,0,.2-.08.41-.13.61a1.78,1.78,0,0,0-.07.65.1.1,0,0,0,.18.05A3.21,3.21,0,0,0,134.23,290.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.57 310.32 87.55 321.46 90.88 359.1 120.35 359.1 124.51 321.46 125.74 310.32 86.57 310.32",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.57 310.32 87.55 321.46 124.51 321.46 125.74 310.32 86.57 310.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.65,
    y: 307.28,
    width: 45.01,
    height: 9.04,
    transform: "translate(212.31 623.6) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 359.19 131.79 358.94 212.86 358.86 375 358.69 537.14 358.86 618.21 358.94 699.28 359.19 618.21 359.43 537.14 359.52 375 359.69 212.86 359.52 131.79 359.43 50.72 359.19",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 138.36,
    y: 63.91,
    width: 471.59,
    height: 315.46,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.79,
    y: 67.76,
    width: 464.73,
    height: 307.76,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.94,
    y: 403.03,
    width: 594.43,
    height: 21.65,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.94 403.03 138.37 379.37 609.95 379.37 671.38 403.03 76.94 403.03",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.85 394.64 183.49 379.37 564.83 379.37 604.47 394.64 143.85 394.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.06,
    y: 91.14,
    width: 412.21,
    height: 261,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.06,
    y: 91.14,
    width: 412.21,
    height: 10.04,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.25,96.16A2.13,2.13,0,1,1,174.12,94,2.13,2.13,0,0,1,176.25,96.16Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.93,96.16A2.13,2.13,0,1,1,182.8,94,2.13,2.13,0,0,1,184.93,96.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.61,96.16A2.13,2.13,0,1,1,191.48,94,2.13,2.13,0,0,1,193.61,96.16Z",
    style: {
      fill: "#92E3A9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screens--inject-42"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.57,
    y: 99.76,
    width: 412.21,
    height: 261,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572,361H159.32V99.51H572Zm-412.21-.5H571.53V100H159.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.57,
    y: 99.76,
    width: 412.21,
    height: 10.04,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.77,104.78a2.13,2.13,0,1,1-2.13-2.12A2.13,2.13,0,0,1,167.77,104.78Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.45,104.78a2.13,2.13,0,1,1-2.13-2.12A2.13,2.13,0,0,1,176.45,104.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.13,104.78a2.13,2.13,0,1,1-2.13-2.12A2.13,2.13,0,0,1,185.13,104.78Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.57,
    y: 109.81,
    width: 412.21,
    height: 23.79,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.57,
    y: 133.6,
    width: 412.21,
    height: 16.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 115.11,
    width: 7.99,
    height: 7.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.76,
    y: 115.11,
    width: 84.85,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.48,
    y: 136.04,
    width: 7.99,
    height: 7.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.2,
    y: 140.03,
    width: 7.99,
    height: 7.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.62,
    y: 136.04,
    width: 84.85,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.62,
    y: 144.03,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.33,
    y: 144.03,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.05,
    y: 144.03,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.77,
    y: 144.03,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.57,
    y: 136.04,
    width: 9.14,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.57,
    y: 144.03,
    width: 9.14,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.29,
    y: 136.04,
    width: 4.57,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.29,
    y: 144.03,
    width: 4.57,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.07,
    y: 136.04,
    width: 8.95,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.07,
    y: 144.03,
    width: 8.95,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.29,
    y: 136.04,
    width: 65.45,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.29,
    y: 144.03,
    width: 65.45,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.81,
    y: 136.04,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.17,
    y: 136.04,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.54,
    y: 136.04,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.9,
    y: 136.04,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.27,
    y: 136.04,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.91,
    y: 136.04,
    width: 11.98,
    height: 2.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.91,
    y: 140.85,
    width: 11.98,
    height: 2.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.91,
    y: 145.66,
    width: 11.98,
    height: 2.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 202.04,
    width: 167.46,
    height: 12.89,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.39,
    y: 202.04,
    width: 41.86,
    height: 12.89,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 214.94,
    width: 167.46,
    height: 77.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.39,
    y: 214.94,
    width: 41.86,
    height: 77.37,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 305.2,
    width: 167.46,
    height: 12.89,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.39,
    y: 305.2,
    width: 41.86,
    height: 12.89,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.79,
    y: 318.09,
    width: 167.46,
    height: 25.79,
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 507.39,
    y: 318.09,
    width: 41.86,
    height: 25.79,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159.57,
    y: 150.46,
    width: 12.89,
    height: 210.3,
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.68,
    y: -42.75,
    width: 12.89,
    height: 399.31,
    transform: "translate(215.21 529.04) rotate(-90)",
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.47,150.46a49.82,49.82,0,0,1,.37,6.45,48.11,48.11,0,0,1-.37,6.45,48.12,48.12,0,0,1-.38-6.45A49.84,49.84,0,0,1,172.47,150.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.33,150.46a54.93,54.93,0,0,1,0,12.9,56.4,56.4,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.2,150.46a49.82,49.82,0,0,1,.37,6.45,48.11,48.11,0,0,1-.37,6.45,48.12,48.12,0,0,1-.38-6.45A49.84,49.84,0,0,1,256.2,150.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.06,150.46a54.93,54.93,0,0,1,0,12.9,56.4,56.4,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,150.46a56.4,56.4,0,0,1,0,12.9,48.12,48.12,0,0,1-.38-6.45A49.84,49.84,0,0,1,339.93,150.46Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.79,150.46a54.93,54.93,0,0,1,0,12.9,56.4,56.4,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.66,150.46a56.4,56.4,0,0,1,0,12.9,54.93,54.93,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.52,150.46a54.93,54.93,0,0,1,0,12.9,56.4,56.4,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.39,150.46a56.4,56.4,0,0,1,0,12.9,54.93,54.93,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.25,150.46a49.84,49.84,0,0,1,.38,6.45,48.12,48.12,0,0,1-.38,6.45,56.4,56.4,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,163.36A49.84,49.84,0,0,1,166,163a48.12,48.12,0,0,1,6.45.38,48.11,48.11,0,0,1-6.45.37A49.82,49.82,0,0,1,159.57,163.36Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,176.25a56.4,56.4,0,0,1,12.9,0,54.93,54.93,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,189.15a54.93,54.93,0,0,1,12.9,0,56.4,56.4,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,202a56.4,56.4,0,0,1,12.9,0,48.12,48.12,0,0,1-6.45.38A49.84,49.84,0,0,1,159.57,202Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,214.94a54.93,54.93,0,0,1,12.9,0,56.4,56.4,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,227.83a49.82,49.82,0,0,1,6.45-.37,48.11,48.11,0,0,1,6.45.37,48.12,48.12,0,0,1-6.45.38A49.84,49.84,0,0,1,159.57,227.83Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,240.73a54.93,54.93,0,0,1,12.9,0,56.4,56.4,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,253.62a54.93,54.93,0,0,1,12.9,0A48.11,48.11,0,0,1,166,254,49.82,49.82,0,0,1,159.57,253.62Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,266.51a56.4,56.4,0,0,1,12.9,0,54.93,54.93,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,279.41A49.84,49.84,0,0,1,166,279a48.12,48.12,0,0,1,6.45.38,48.11,48.11,0,0,1-6.45.37A49.82,49.82,0,0,1,159.57,279.41Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,292.3a56.4,56.4,0,0,1,12.9,0,54.93,54.93,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,305.2a54.93,54.93,0,0,1,12.9,0,56.4,56.4,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,318.09a56.4,56.4,0,0,1,12.9,0,48.12,48.12,0,0,1-6.45.38A49.84,49.84,0,0,1,159.57,318.09Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,331a54.93,54.93,0,0,1,12.9,0,56.4,56.4,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,343.88a49.82,49.82,0,0,1,6.45-.37,48.11,48.11,0,0,1,6.45.37,54.93,54.93,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.57,356.77a56.4,56.4,0,0,1,12.9,0,54.93,54.93,0,0,1-12.9,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.33 163.36 214.52 188.03 214.58 212.71 214.71 262.06 214.58 311.41 214.52 336.08 214.33 360.76 214.15 336.08 214.08 311.41 213.96 262.06 214.09 212.71 214.15 188.03 214.33 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.2 163.36 256.38 188.03 256.45 212.71 256.57 262.06 256.45 311.41 256.38 336.08 256.2 360.76 256.01 336.08 255.95 311.41 255.82 262.06 255.95 212.71 256.02 188.03 256.2 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.06 163.36 298.25 188.03 298.31 212.71 298.44 262.06 298.31 311.41 298.25 336.08 298.06 360.76 297.88 336.08 297.81 311.41 297.69 262.06 297.81 212.71 297.88 188.03 298.06 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.93 163.36 340.11 188.03 340.18 212.71 340.3 262.06 340.18 311.41 340.11 336.08 339.93 360.76 339.74 336.08 339.68 311.41 339.55 262.06 339.68 212.71 339.75 188.03 339.93 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.79 163.36 381.98 188.03 382.04 212.71 382.17 262.06 382.04 311.41 381.98 336.08 381.79 360.76 381.61 336.08 381.54 311.41 381.42 262.06 381.54 212.71 381.61 188.03 381.79 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.66 163.36 423.84 188.03 423.91 212.71 424.03 262.06 423.91 311.41 423.84 336.08 423.66 360.76 423.47 336.08 423.41 311.41 423.28 262.06 423.41 212.71 423.48 188.03 423.66 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.52 163.36 465.7 188.03 465.77 212.71 465.9 262.06 465.77 311.41 465.71 336.08 465.52 360.76 465.34 336.08 465.27 311.41 465.15 262.06 465.27 212.71 465.34 188.03 465.52 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.39 163.36 507.57 188.03 507.63 212.71 507.76 262.06 507.64 311.41 507.57 336.08 507.39 360.76 507.2 336.08 507.14 311.41 507.01 262.06 507.14 212.71 507.2 188.03 507.39 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "549.25 163.36 549.43 188.03 549.5 212.71 549.63 262.06 549.5 311.41 549.43 336.08 549.25 360.76 549.07 336.08 549 311.41 548.88 262.06 549 212.71 549.07 188.03 549.25 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 163.36 222.25 163.18 272.18 163.11 372.05 162.99 471.92 163.11 521.85 163.18 571.78 163.36 521.85 163.54 471.92 163.61 372.05 163.73 272.18 163.61 222.25 163.54 172.31 163.36",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 176.25 222.25 176.07 272.18 176 372.05 175.88 471.92 176 521.85 176.07 571.78 176.25 521.85 176.44 471.92 176.5 372.05 176.63 272.18 176.5 222.25 176.44 172.31 176.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 189.15 222.25 188.97 272.18 188.9 372.05 188.77 471.92 188.9 521.85 188.96 571.78 189.15 521.85 189.33 471.92 189.4 372.05 189.52 272.18 189.4 222.25 189.33 172.31 189.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 202.04 222.25 201.86 272.18 201.79 372.05 201.67 471.92 201.79 521.85 201.86 571.78 202.04 521.85 202.23 471.92 202.29 372.05 202.42 272.18 202.29 222.25 202.22 172.31 202.04",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 214.94 222.25 214.75 272.18 214.69 372.05 214.56 471.92 214.69 521.85 214.75 571.78 214.94 521.85 215.12 471.92 215.19 372.05 215.31 272.18 215.19 222.25 215.12 172.31 214.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 227.83 222.25 227.65 272.18 227.58 372.05 227.46 471.92 227.58 521.85 227.65 571.78 227.83 521.85 228.01 471.92 228.08 372.05 228.21 272.18 228.08 222.25 228.01 172.31 227.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 240.72 222.25 240.54 272.18 240.48 372.05 240.35 471.92 240.48 521.85 240.54 571.78 240.72 521.85 240.91 471.92 240.97 372.05 241.1 272.18 240.97 222.25 240.91 172.31 240.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 253.62 222.25 253.44 272.18 253.37 372.05 253.25 471.92 253.37 521.85 253.44 571.78 253.62 521.85 253.8 471.92 253.87 372.05 253.99 272.18 253.87 222.25 253.8 172.31 253.62",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 266.51 222.25 266.33 272.18 266.27 372.05 266.14 471.92 266.26 521.85 266.33 571.78 266.51 521.85 266.7 471.92 266.76 372.05 266.89 272.18 266.76 222.25 266.7 172.31 266.51",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 279.41 222.25 279.23 272.18 279.16 372.05 279.03 471.92 279.16 521.85 279.23 571.78 279.41 521.85 279.59 471.92 279.66 372.05 279.78 272.18 279.66 222.25 279.59 172.31 279.41",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 292.3 222.25 292.12 272.18 292.05 372.05 291.93 471.92 292.05 521.85 292.12 571.78 292.3 521.85 292.49 471.92 292.55 372.05 292.68 272.18 292.55 222.25 292.49 172.31 292.3",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 305.2 222.25 305.01 272.18 304.95 372.05 304.82 471.92 304.95 521.85 305.01 571.78 305.2 521.85 305.38 471.92 305.45 372.05 305.57 272.18 305.45 222.25 305.38 172.31 305.2",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 318.09 222.25 317.91 272.18 317.84 372.05 317.72 471.92 317.84 521.85 317.91 571.78 318.09 521.85 318.27 471.92 318.34 372.05 318.47 272.18 318.34 222.25 318.27 172.31 318.09",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 330.99 222.25 330.8 272.18 330.74 372.05 330.61 471.92 330.74 521.85 330.8 571.78 330.99 521.85 331.17 471.92 331.24 372.05 331.36 272.18 331.24 222.25 331.17 172.31 330.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 343.88 222.25 343.7 272.18 343.63 372.05 343.51 471.92 343.63 521.85 343.7 571.78 343.88 521.85 344.06 471.92 344.13 372.05 344.25 272.18 344.13 222.25 344.06 172.31 343.88",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.31 356.77 222.25 356.59 272.18 356.53 372.05 356.4 471.92 356.53 521.85 356.59 571.78 356.77 521.85 356.96 471.92 357.02 372.05 357.15 272.18 357.02 222.25 356.96 172.31 356.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.15,
    y: -23.4,
    width: 25.79,
    height: 399.31,
    transform: "translate(195.79 548.3) rotate(-90)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,173.13c8-.22,16-.32,24-.49l24-.27c16-.17,32-.15,48.05-.24,16,.08,32,.07,48,.23l24,.28c8,.17,16,.26,24,.49-8,.23-16,.33-24,.49l-24,.28c-16,.16-32,.15-48,.23-16-.08-32-.07-48.05-.23l-24-.28C292.06,173.45,284.05,173.36,276,173.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.41,179.38c6.48-.23,12.95-.33,19.43-.49l19.43-.28c13-.16,25.9-.15,38.86-.23,12.95.07,25.9.07,38.85.23l19.43.28c6.48.16,13,.26,19.43.49-6.47.22-12.95.32-19.43.49l-19.43.27c-13,.16-25.9.16-38.85.23-13-.08-25.91-.06-38.86-.23l-19.43-.28C307.36,179.7,300.89,179.6,294.41,179.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,208.49q13.55-.59,27.08-.78c9-.16,18.06-.2,27.09-.22s18.05.06,27.08.22,18.06.39,27.08.78q-13.53.58-27.08.78c-9,.16-18.06.2-27.08.22s-18.06-.06-27.09-.22S399.17,208.88,390.14,208.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.65,208.49a67,67,0,0,1,7.16-.78c2.38-.16,4.77-.2,7.15-.22s4.78.06,7.16.22a64.47,64.47,0,0,1,7.16.78,64.47,64.47,0,0,1-7.16.78c-2.38.16-4.77.2-7.16.22s-4.77-.06-7.15-.22A67,67,0,0,1,513.65,208.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,221.38c5.08-.41,10.16-.63,15.24-.77s10.16-.21,15.23-.23,10.16.06,15.24.22,10.16.37,15.24.78c-5.08.42-10.16.64-15.24.78s-10.16.21-15.24.22-10.15-.06-15.23-.22S395.22,221.8,390.14,221.38Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.88,221.38c3.17-.41,6.33-.63,9.49-.77s6.32-.21,9.48-.23,6.32.06,9.48.22,6.33.37,9.49.78c-3.16.42-6.32.64-9.49.78s-6.32.21-9.48.22-6.32-.06-9.48-.22S461.05,221.8,457.88,221.38Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.61,221.38a51.09,51.09,0,0,1,6.36-.77c2.11-.16,4.23-.21,6.35-.23s4.24.06,6.35.22a53.08,53.08,0,0,1,6.36.78,49.3,49.3,0,0,1-6.36.78c-2.11.16-4.23.21-6.35.22s-4.24-.06-6.35-.22A51.12,51.12,0,0,1,515.61,221.38Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.48,234.28a33.67,33.67,0,0,1,5.13-.78c1.72-.15,3.43-.22,5.14-.22s3.43.07,5.14.22a32.77,32.77,0,0,1,5.14.78,35.3,35.3,0,0,1-5.14.78c-1.71.14-3.43.22-5.14.22s-3.42-.08-5.14-.22A35,35,0,0,1,520.48,234.28Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.29,247.17a20.22,20.22,0,0,1,3.93-.77,34.7,34.7,0,0,1,3.94-.23,37,37,0,0,1,3.93.22,21.13,21.13,0,0,1,3.94.78,19.63,19.63,0,0,1-3.94.78,32.36,32.36,0,0,1-3.93.22,34.69,34.69,0,0,1-3.94-.22A20.25,20.25,0,0,1,525.29,247.17Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.61,260.07a51.12,51.12,0,0,1,6.36-.78c2.11-.16,4.23-.2,6.35-.22s4.24.06,6.35.22a49.3,49.3,0,0,1,6.36.78,53.08,53.08,0,0,1-6.36.78c-2.11.16-4.23.2-6.35.22s-4.24-.07-6.35-.23A51.09,51.09,0,0,1,515.61,260.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.48,273a35,35,0,0,1,5.13-.78c1.72-.14,3.43-.22,5.14-.22s3.43.08,5.14.22A35.3,35.3,0,0,1,541,273a32.77,32.77,0,0,1-5.14.78c-1.71.15-3.43.23-5.14.22s-3.42-.08-5.14-.22A33.67,33.67,0,0,1,520.48,273Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.61,285.86a51.12,51.12,0,0,1,6.36-.78c2.11-.16,4.23-.2,6.35-.22s4.24.06,6.35.22a49.3,49.3,0,0,1,6.36.78,53.08,53.08,0,0,1-6.36.78c-2.11.16-4.23.2-6.35.22s-4.24-.07-6.35-.23A51.09,51.09,0,0,1,515.61,285.86Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,234.28q8.48-.59,16.94-.78c5.64-.16,11.29-.2,16.93-.22s11.29.06,16.94.22,11.29.39,16.93.78q-8.46.58-16.93.78c-5.65.16-11.29.2-16.94.22s-11.29-.06-16.93-.22S395.79,234.66,390.14,234.28Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,247.17q11.26-.57,22.54-.77c7.51-.16,15-.21,22.54-.23s15,.06,22.53.22,15,.39,22.54.78q-11.27.59-22.54.78c-7.51.16-15,.2-22.53.22s-15-.06-22.54-.22S397.65,247.56,390.14,247.17Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,260.07c5.08-.42,10.16-.63,15.24-.78s10.16-.2,15.23-.22,10.16.06,15.24.22,10.16.36,15.24.78c-5.08.41-10.16.63-15.24.78s-10.16.2-15.24.22-10.15-.07-15.23-.23S395.22,260.48,390.14,260.07Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,273q9.42-.58,18.85-.78c6.28-.16,12.56-.2,18.84-.22s12.57.06,18.85.22,12.56.39,18.84.78q-9.42.59-18.84.78c-6.28.16-12.57.2-18.85.22s-12.56-.06-18.84-.22S396.42,273.35,390.14,273Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,285.86a75.71,75.71,0,0,1,7.77-.78c2.59-.16,5.18-.2,7.76-.22s5.18.06,7.77.22a73,73,0,0,1,7.77.78c-2.59.41-5.18.63-7.77.78s-5.18.2-7.77.22-5.17-.07-7.76-.23A75.68,75.68,0,0,1,390.14,285.86Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,311.64q13.55-.57,27.08-.77c9-.16,18.06-.2,27.09-.22s18.05.06,27.08.21,18.06.4,27.08.78q-13.53.58-27.08.78c-9,.16-18.06.21-27.08.22s-18.06-.06-27.09-.22S399.17,312,390.14,311.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.65,311.64a64.44,64.44,0,0,1,7.16-.77c2.38-.16,4.77-.2,7.15-.22s4.78.06,7.16.21a67,67,0,0,1,7.16.78,62.17,62.17,0,0,1-7.16.78c-2.38.16-4.77.21-7.16.22s-4.77-.06-7.15-.22A64.47,64.47,0,0,1,513.65,311.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,324.54c5.08-.41,10.16-.63,15.24-.78s10.16-.2,15.23-.22,10.16.06,15.24.22,10.16.36,15.24.78c-5.08.42-10.16.63-15.24.78s-10.16.2-15.24.22-10.15-.06-15.23-.22S395.22,325,390.14,324.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.88,324.54c3.17-.41,6.33-.63,9.49-.78s6.32-.2,9.48-.22,6.32.06,9.48.22,6.33.36,9.49.78c-3.16.42-6.32.63-9.49.78s-6.32.2-9.48.22-6.32-.06-9.48-.22S461.05,325,457.88,324.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.61,324.54a53.08,53.08,0,0,1,6.36-.78c2.11-.16,4.23-.2,6.35-.22s4.24.06,6.35.22a51.12,51.12,0,0,1,6.36.78,51.12,51.12,0,0,1-6.36.78c-2.11.16-4.23.2-6.35.22s-4.24-.06-6.35-.22A53.08,53.08,0,0,1,515.61,324.54Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.48,337.43a33.64,33.64,0,0,1,5.13-.77c1.72-.15,3.43-.23,5.14-.23s3.43.08,5.14.22a35.3,35.3,0,0,1,5.14.78,32.77,32.77,0,0,1-5.14.78c-1.71.15-3.43.23-5.14.22s-3.42-.07-5.14-.22A33.67,33.67,0,0,1,520.48,337.43Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.14,337.43q8.48-.57,16.94-.77c5.64-.16,11.29-.21,16.93-.23s11.29.06,16.94.22,11.29.39,16.93.78q-8.46.58-16.93.78c-5.65.16-11.29.21-16.94.22s-11.29-.06-16.93-.22S395.79,337.82,390.14,337.43Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,205.84l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.12-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,211.53l64.54-.18c21.51.06,43,0,64.54.18-21.51.16-43,.12-64.54.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,217.22l64.54-.18c21.51.06,43,0,64.54.18-21.51.16-43,.12-64.54.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,222.92l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.12-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,228.61l64.54-.18c21.51.06,43,0,64.54.18-21.51.16-43,.12-64.54.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,234.3l64.54-.18c21.51.07,43,0,64.54.18-21.51.16-43,.12-64.54.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,240l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.12-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,245.69l64.54-.18c21.51.06,43,0,64.54.18-21.51.16-43,.12-64.54.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,251.39l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.11-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,257.08l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.12-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,262.77l64.54-.18c21.51.06,43,0,64.54.18-21.51.16-43,.12-64.54.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,268.47l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.11-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,274.16l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.12-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,279.85l64.54-.18c21.51.06,43,0,64.54.18-21.51.16-43,.12-64.54.19Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,285.55l64.54-.19c21.51.07,43,0,64.54.19-21.51.16-43,.12-64.54.18Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 245.69,
    width: 9.79,
    height: 46.49,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.66,
    y: 226.03,
    width: 9.79,
    height: 66.16,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.82,
    y: 240.2,
    width: 9.79,
    height: 51.99,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.98,
    y: 222.92,
    width: 9.79,
    height: 69.27,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.13,
    y: 232.21,
    width: 9.79,
    height: 59.98,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.29,
    y: 266.19,
    width: 9.79,
    height: 25.99,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.36,201.84l.26,22.59.19,22.58q.18,22.59.18,45.17l-.63-.68,31.39,0,31.39.08,31.4.22,31.39.41-31.39.41-31.4.23-31.39.08-31.39,0h-.64v-.69q0-22.57.19-45.17l.18-22.58Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.5,
    y: 296.96,
    width: 9.79,
    height: 0.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242.66,
    y: 296.96,
    width: 9.79,
    height: 0.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.82,
    y: 296.96,
    width: 9.79,
    height: 0.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.98,
    y: 296.96,
    width: 9.79,
    height: 0.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.13,
    y: 296.96,
    width: 9.79,
    height: 0.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.29,
    y: 296.96,
    width: 9.79,
    height: 0.96,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.59,
    y: 308.87,
    width: 5.42,
    height: 5.42,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.59,
    y: 321.83,
    width: 5.42,
    height: 5.42,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.59,
    y: 334.79,
    width: 5.42,
    height: 5.42,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,309.79c3.44-.41,6.88-.63,10.33-.78s6.89-.2,10.33-.22,6.89.06,10.33.22,6.89.37,10.33.78c-3.44.42-6.89.64-10.33.78s-6.89.2-10.33.22-6.89-.06-10.33-.22S229,310.21,225.53,309.79Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,313.37a60.3,60.3,0,0,1,6.92-.78c2.31-.16,4.61-.2,6.92-.22s4.62.06,6.92.22a58.31,58.31,0,0,1,6.93.78,62.79,62.79,0,0,1-6.93.78c-2.3.16-4.61.2-6.92.22s-4.61-.06-6.92-.22A62.61,62.61,0,0,1,225.53,313.37Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,322.75a29.6,29.6,0,0,1,4.72-.78c1.57-.14,3.14-.22,4.71-.22s3.15.08,4.72.22a28.69,28.69,0,0,1,4.72.78,28.69,28.69,0,0,1-4.72.78,46.46,46.46,0,0,1-4.72.22c-1.57,0-3.14-.08-4.71-.22A29.6,29.6,0,0,1,225.53,322.75Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,326.33a79.21,79.21,0,0,1,7.95-.78c2.65-.16,5.31-.2,8-.22s5.3.06,7.95.22a76.57,76.57,0,0,1,8,.78c-2.65.41-5.31.63-8,.78s-5.3.2-7.95.22-5.31-.07-8-.23A79.18,79.18,0,0,1,225.53,326.33Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,335.71c2.84-.41,5.69-.63,8.53-.78s5.69-.2,8.54-.22,5.69.06,8.53.22,5.69.36,8.54.78c-2.85.42-5.69.63-8.54.78s-5.69.2-8.53.22-5.69-.06-8.54-.22S228.37,336.12,225.53,335.71Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.53,339.29c3.72-.42,7.44-.63,11.16-.78s7.43-.2,11.15-.22,7.44.06,11.16.22,7.44.36,11.16.78c-3.72.41-7.44.63-11.16.78s-7.44.2-11.16.21-7.44-.06-11.15-.22S229.25,339.7,225.53,339.29Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.22,
    y: 78.99,
    width: 412.21,
    height: 261,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.68,340.24H178V78.74H590.68Zm-412.21-.5H590.18V79.24H178.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.22,
    y: 78.99,
    width: 412.21,
    height: 10.04,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.41,84a2.13,2.13,0,1,1-2.12-2.12A2.12,2.12,0,0,1,186.41,84Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.09,84A2.13,2.13,0,1,1,193,81.89,2.12,2.12,0,0,1,195.09,84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201.64,
    cy: 84.01,
    r: 2.13,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.22,
    y: 89.03,
    width: 412.21,
    height: 23.79,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.22,
    y: 112.82,
    width: 412.21,
    height: 16.87,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.12,
    y: 94.34,
    width: 7.99,
    height: 7.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.4,
    y: 94.34,
    width: 84.85,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.12,
    y: 115.26,
    width: 7.99,
    height: 7.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.84,
    y: 119.26,
    width: 7.99,
    height: 7.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.26,
    y: 115.26,
    width: 84.85,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.26,
    y: 123.25,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.98,
    y: 123.25,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.69,
    y: 123.25,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.41,
    y: 123.25,
    width: 16.7,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.22,
    y: 115.26,
    width: 9.14,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.22,
    y: 123.25,
    width: 9.14,
    height: 3.99,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 115.26,
    width: 4.57,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.93,
    y: 123.25,
    width: 4.57,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.71,
    y: 115.26,
    width: 8.95,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.71,
    y: 123.25,
    width: 8.95,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.94,
    y: 115.26,
    width: 65.45,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.94,
    y: 123.25,
    width: 65.45,
    height: 3.99,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.45,
    y: 115.26,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.81,
    y: 115.26,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.18,
    y: 115.26,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 465.55,
    y: 115.26,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 483.91,
    y: 115.26,
    width: 11.98,
    height: 11.98,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.56,
    y: 115.26,
    width: 11.98,
    height: 2.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.56,
    y: 120.08,
    width: 11.98,
    height: 2.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 570.56,
    y: 124.89,
    width: 11.98,
    height: 2.36,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.98,
    y: 181.27,
    width: 167.46,
    height: 12.89,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.57,
    y: 181.27,
    width: 41.86,
    height: 12.89,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.98,
    y: 194.16,
    width: 167.46,
    height: 77.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.57,
    y: 194.16,
    width: 41.86,
    height: 77.37,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.98,
    y: 284.42,
    width: 167.46,
    height: 12.89,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.57,
    y: 284.42,
    width: 41.86,
    height: 12.89,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.98,
    y: 297.32,
    width: 167.46,
    height: 25.79,
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.57,
    y: 297.32,
    width: 41.86,
    height: 25.79,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.22,
    y: 129.69,
    width: 12.89,
    height: 210.3,
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.32,
    y: -63.52,
    width: 12.89,
    height: 399.31,
    transform: "translate(254.63 526.91) rotate(-90)",
    style: {
      fill: "#92E3A9",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.11,129.69a49.84,49.84,0,0,1,.38,6.45,48.12,48.12,0,0,1-.38,6.45,56.4,56.4,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,129.69a56.4,56.4,0,0,1,0,12.9,54.93,54.93,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.84,129.69a49.84,49.84,0,0,1,.38,6.45,48.12,48.12,0,0,1-.38,6.45,48.11,48.11,0,0,1-.37-6.45A49.82,49.82,0,0,1,274.84,129.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.71,129.69a56.4,56.4,0,0,1,0,12.9,54.93,54.93,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.57,129.69a49.84,49.84,0,0,1,.38,6.45,48.12,48.12,0,0,1-.38,6.45,48.11,48.11,0,0,1-.37-6.45A49.82,49.82,0,0,1,358.57,129.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.44,129.69a56.4,56.4,0,0,1,0,12.9,54.93,54.93,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.3,129.69a49.84,49.84,0,0,1,.38,6.45,48.12,48.12,0,0,1-.38,6.45,48.11,48.11,0,0,1-.37-6.45A49.82,49.82,0,0,1,442.3,129.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.17,129.69a56.4,56.4,0,0,1,0,12.9,54.93,54.93,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,129.69a54.93,54.93,0,0,1,0,12.9,48.11,48.11,0,0,1-.37-6.45A49.82,49.82,0,0,1,526,129.69Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.9,129.69a56.4,56.4,0,0,1,0,12.9,54.93,54.93,0,0,1,0-12.9Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,142.59a54.85,54.85,0,0,1,12.89,0,56.32,56.32,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,155.48a49.77,49.77,0,0,1,6.44-.37,48.11,48.11,0,0,1,6.45.37,48.11,48.11,0,0,1-6.45.37A49.77,49.77,0,0,1,178.22,155.48Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,168.37a56.32,56.32,0,0,1,12.89,0,54.85,54.85,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,181.27a49.79,49.79,0,0,1,6.44-.38,48.12,48.12,0,0,1,6.45.38,48.11,48.11,0,0,1-6.45.37A49.77,49.77,0,0,1,178.22,181.27Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,194.16a56.32,56.32,0,0,1,12.89,0,54.85,54.85,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,207.06a54.85,54.85,0,0,1,12.89,0,56.32,56.32,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,220a56.32,56.32,0,0,1,12.89,0,48.12,48.12,0,0,1-6.45.38A49.79,49.79,0,0,1,178.22,220Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,232.85a54.85,54.85,0,0,1,12.89,0,56.32,56.32,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,245.74a49.77,49.77,0,0,1,6.44-.37,48.11,48.11,0,0,1,6.45.37,54.85,54.85,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,258.64a54.85,54.85,0,0,1,12.89,0,56.32,56.32,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,271.53a54.85,54.85,0,0,1,12.89,0,48.11,48.11,0,0,1-6.45.37A49.77,49.77,0,0,1,178.22,271.53Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,284.42a56.32,56.32,0,0,1,12.89,0,54.85,54.85,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,297.32a49.79,49.79,0,0,1,6.44-.38,48.12,48.12,0,0,1,6.45.38,48.11,48.11,0,0,1-6.45.37A49.77,49.77,0,0,1,178.22,297.32Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,310.21a56.32,56.32,0,0,1,12.89,0,54.85,54.85,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,323.11a54.85,54.85,0,0,1,12.89,0,56.32,56.32,0,0,1-12.89,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,336a49.77,49.77,0,0,1,6.44-.37,48.11,48.11,0,0,1,6.45.37,48.12,48.12,0,0,1-6.45.38A49.79,49.79,0,0,1,178.22,336Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.98 142.59 233.16 167.26 233.22 191.94 233.35 241.29 233.23 290.64 233.16 315.31 232.98 339.99 232.79 315.31 232.73 290.64 232.6 241.29 232.73 191.94 232.79 167.26 232.98 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "274.84 142.59 275.02 167.26 275.09 191.94 275.22 241.29 275.09 290.64 275.02 315.31 274.84 339.99 274.66 315.31 274.59 290.64 274.47 241.29 274.59 191.94 274.66 167.26 274.84 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.71 142.59 316.89 167.26 316.95 191.94 317.08 241.29 316.96 290.64 316.89 315.31 316.71 339.99 316.52 315.31 316.46 290.64 316.33 241.29 316.46 191.94 316.52 167.26 316.71 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "358.57 142.59 358.75 167.26 358.82 191.94 358.94 241.29 358.82 290.64 358.75 315.31 358.57 339.99 358.39 315.31 358.32 290.64 358.2 241.29 358.32 191.94 358.39 167.26 358.57 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.44 142.59 400.62 167.26 400.68 191.94 400.81 241.29 400.69 290.64 400.62 315.31 400.44 339.99 400.25 315.31 400.19 290.64 400.06 241.29 400.19 191.94 400.25 167.26 400.44 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.3 142.59 442.48 167.26 442.55 191.94 442.68 241.29 442.55 290.64 442.48 315.31 442.3 339.99 442.12 315.31 442.05 290.64 441.93 241.29 442.05 191.94 442.12 167.26 442.3 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.17 142.59 484.35 167.26 484.41 191.94 484.54 241.29 484.42 290.64 484.35 315.31 484.17 339.99 483.98 315.31 483.92 290.64 483.79 241.29 483.92 191.94 483.98 167.26 484.17 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526.03 142.59 526.21 167.26 526.28 191.94 526.4 241.29 526.28 290.64 526.21 315.31 526.03 339.99 525.85 315.31 525.78 290.64 525.66 241.29 525.78 191.94 525.85 167.26 526.03 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "567.89 142.59 568.08 167.26 568.14 191.94 568.27 241.29 568.14 290.64 568.08 315.31 567.89 339.99 567.71 315.31 567.65 290.64 567.52 241.29 567.65 191.94 567.71 167.26 567.89 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 142.59 240.89 142.4 290.82 142.34 390.69 142.21 490.56 142.34 540.49 142.4 590.43 142.59 540.49 142.77 490.56 142.84 390.69 142.96 290.82 142.83 240.89 142.77 190.96 142.59",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 155.48 240.89 155.3 290.82 155.23 390.69 155.11 490.56 155.23 540.49 155.3 590.43 155.48 540.49 155.66 490.56 155.73 390.69 155.85 290.82 155.73 240.89 155.66 190.96 155.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 168.37 240.89 168.19 290.82 168.13 390.69 168 490.56 168.13 540.49 168.19 590.43 168.37 540.49 168.56 490.56 168.62 390.69 168.75 290.82 168.62 240.89 168.56 190.96 168.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 181.27 240.89 181.09 290.82 181.02 390.69 180.9 490.56 181.02 540.49 181.09 590.43 181.27 540.49 181.45 490.56 181.52 390.69 181.64 290.82 181.52 240.89 181.45 190.96 181.27",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 194.16 240.89 193.98 290.82 193.91 390.69 193.79 490.56 193.91 540.49 193.98 590.43 194.16 540.49 194.35 490.56 194.41 390.69 194.54 290.82 194.41 240.89 194.34 190.96 194.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 207.06 240.89 206.88 290.82 206.81 390.69 206.68 490.56 206.81 540.49 206.87 590.43 207.06 540.49 207.24 490.56 207.31 390.69 207.43 290.82 207.31 240.89 207.24 190.96 207.06",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 219.95 240.89 219.77 290.82 219.7 390.69 219.58 490.56 219.7 540.49 219.77 590.43 219.95 540.49 220.13 490.56 220.2 390.69 220.33 290.82 220.2 240.89 220.13 190.96 219.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 232.85 240.89 232.66 290.82 232.6 390.69 232.47 490.56 232.6 540.49 232.66 590.43 232.85 540.49 233.03 490.56 233.1 390.69 233.22 290.82 233.09 240.89 233.03 190.96 232.85",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 245.74 240.89 245.56 290.82 245.49 390.69 245.37 490.56 245.49 540.49 245.56 590.43 245.74 540.49 245.92 490.56 245.99 390.69 246.12 290.82 245.99 240.89 245.92 190.96 245.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 258.63 240.89 258.45 290.82 258.39 390.69 258.26 490.56 258.39 540.49 258.45 590.43 258.63 540.49 258.82 490.56 258.88 390.69 259.01 290.82 258.88 240.89 258.82 190.96 258.63",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 271.53 240.89 271.35 290.82 271.28 390.69 271.15 490.56 271.28 540.49 271.35 590.43 271.53 540.49 271.71 490.56 271.78 390.69 271.9 290.82 271.78 240.89 271.71 190.96 271.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 284.42 240.89 284.24 290.82 284.18 390.69 284.05 490.56 284.18 540.49 284.24 590.43 284.42 540.49 284.61 490.56 284.67 390.69 284.8 290.82 284.67 240.89 284.61 190.96 284.42",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 297.32 240.89 297.14 290.82 297.07 390.69 296.94 490.56 297.07 540.49 297.13 590.43 297.32 540.49 297.5 490.56 297.57 390.69 297.69 290.82 297.57 240.89 297.5 190.96 297.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 310.21 240.89 310.03 290.82 309.96 390.69 309.84 490.56 309.96 540.49 310.03 590.43 310.21 540.49 310.4 490.56 310.46 390.69 310.59 290.82 310.46 240.89 310.39 190.96 310.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 323.11 240.89 322.93 290.82 322.86 390.69 322.73 490.56 322.86 540.49 322.92 590.43 323.11 540.49 323.29 490.56 323.36 390.69 323.48 290.82 323.36 240.89 323.29 190.96 323.11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.96 336 240.89 335.82 290.82 335.75 390.69 335.63 490.56 335.75 540.49 335.82 590.43 336 540.49 336.19 490.56 336.25 390.69 336.38 290.82 336.25 240.89 336.18 190.96 336",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.8,
    y: -44.18,
    width: 25.79,
    height: 399.31,
    transform: "translate(235.21 546.17) rotate(-90)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.69,152.36c8-.23,16-.32,24-.49l24-.28c16-.16,32-.15,48-.23,16,.08,32,.07,48,.23l24,.28c8,.16,16,.26,24,.49-8,.22-16,.32-24,.49l-24,.28c-16,.16-32,.15-48,.23-16-.09-32-.07-48-.24l-24-.27C310.7,152.68,302.69,152.58,294.69,152.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.05,158.6c6.48-.22,12.95-.32,19.43-.49l19.43-.27c12.95-.17,25.91-.15,38.86-.24,13,.08,25.9.07,38.86.23l19.43.28c6.47.17,12.95.27,19.43.49-6.48.23-13,.33-19.43.49l-19.43.28c-13,.16-25.91.15-38.86.23-12.95-.08-25.91-.07-38.86-.23l-19.43-.28C326,158.92,319.53,158.83,313.05,158.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,187.72q13.53-.58,27.08-.78c9-.16,18-.2,27.08-.22s18.06.06,27.08.22,18.06.39,27.09.78q-13.55.57-27.09.78c-9,.16-18.05.2-27.08.22s-18.05-.07-27.08-.23S250.35,188.1,241.33,187.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,187.72a64.29,64.29,0,0,1,7.15-.78c2.39-.16,4.77-.2,7.16-.22s4.77.06,7.15.22a61.93,61.93,0,0,1,7.16.78,66.67,66.67,0,0,1-7.16.78c-2.38.16-4.77.2-7.15.22s-4.77-.07-7.16-.23A64.27,64.27,0,0,1,364.84,187.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,200.61c5.07-.41,10.15-.63,15.23-.78s10.16-.2,15.24-.22,10.16.06,15.24.22,10.15.36,15.23.78c-5.08.42-10.16.63-15.23.78s-10.16.2-15.24.22-10.16-.06-15.24-.22S246.4,201,241.33,200.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.07,200.61c3.16-.41,6.32-.63,9.48-.78s6.32-.2,9.49-.22,6.32.06,9.48.22,6.32.36,9.48.78c-3.16.42-6.32.63-9.48.78s-6.32.2-9.48.22-6.33-.06-9.49-.22S312.23,201,309.07,200.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,200.61a52.67,52.67,0,0,1,6.35-.78c2.12-.16,4.24-.2,6.35-.22s4.24.06,6.36.22a51.19,51.19,0,0,1,6.35.78,51.19,51.19,0,0,1-6.35.78c-2.12.16-4.24.2-6.36.22s-4.23-.06-6.35-.22A52.67,52.67,0,0,1,366.8,200.61Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,213.5a33.77,33.77,0,0,1,5.14-.77c1.71-.15,3.42-.23,5.14-.22s3.42.07,5.13.21a34.89,34.89,0,0,1,5.14.78,33.64,33.64,0,0,1-5.14.79c-1.71.14-3.42.22-5.13.21s-3.43-.07-5.14-.22A32.6,32.6,0,0,1,371.66,213.5Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.47,226.4a21,21,0,0,1,3.94-.78,37,37,0,0,1,3.93-.22,32.64,32.64,0,0,1,3.94.22,20.25,20.25,0,0,1,3.93.78,20.25,20.25,0,0,1-3.93.78,35.3,35.3,0,0,1-7.87,0A21,21,0,0,1,376.47,226.4Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,239.29a50.71,50.71,0,0,1,6.35-.77c2.12-.16,4.24-.21,6.35-.23s4.24.06,6.36.22a53.17,53.17,0,0,1,6.35.78,49.36,49.36,0,0,1-6.35.78c-2.12.16-4.24.21-6.36.22s-4.23-.06-6.35-.22A50.73,50.73,0,0,1,366.8,239.29Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,252.19a33.8,33.8,0,0,1,5.14-.78c1.71-.15,3.42-.22,5.14-.22s3.42.07,5.13.22a32.42,32.42,0,0,1,5.14.78,34.89,34.89,0,0,1-5.14.78c-1.71.14-3.42.22-5.13.22s-3.43-.08-5.14-.22A35.1,35.1,0,0,1,371.66,252.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,265.08a50.71,50.71,0,0,1,6.35-.77c2.12-.16,4.24-.21,6.35-.23s4.24.06,6.36.22a53.17,53.17,0,0,1,6.35.78,49.36,49.36,0,0,1-6.35.78c-2.12.16-4.24.2-6.36.22s-4.23-.06-6.35-.22A50.73,50.73,0,0,1,366.8,265.08Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,213.5q8.46-.57,16.93-.77c5.65-.16,11.29-.2,16.94-.22s11.29.06,16.93.21,11.29.4,16.94.78q-8.47.58-16.94.79c-5.64.15-11.29.2-16.93.21s-11.29-.06-16.94-.22S247,213.89,241.33,213.5Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,226.4q11.26-.59,22.53-.78c7.52-.16,15-.2,22.54-.22s15,.06,22.54.22,15,.39,22.53.78q-11.27.58-22.53.78c-7.52.16-15,.2-22.54.22s-15-.06-22.54-.22S248.84,226.79,241.33,226.4Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,239.29c5.07-.41,10.15-.63,15.23-.77s10.16-.21,15.24-.23,10.16.06,15.24.22,10.15.37,15.23.78c-5.08.42-10.16.64-15.23.78s-10.16.21-15.24.22-10.16-.06-15.24-.22S246.4,239.71,241.33,239.29Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,252.19q9.42-.58,18.84-.78c6.28-.16,12.56-.2,18.85-.22s12.56.06,18.84.22,12.56.39,18.85.78q-9.43.59-18.85.78c-6.28.16-12.56.2-18.84.22s-12.57-.07-18.85-.22S247.61,252.57,241.33,252.19Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,265.08a75.22,75.22,0,0,1,7.76-.77c2.59-.16,5.18-.21,7.77-.23s5.18.06,7.77.22,5.17.37,7.76.78a73.09,73.09,0,0,1-7.76.78c-2.59.16-5.18.2-7.77.22s-5.18-.06-7.77-.22A75.24,75.24,0,0,1,241.33,265.08Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,290.87q13.53-.58,27.08-.78c9-.16,18-.2,27.08-.22s18.06.06,27.08.22,18.06.39,27.09.78q-13.55.58-27.09.78c-9,.16-18.05.2-27.08.22s-18.05-.06-27.08-.22S250.35,291.26,241.33,290.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.84,290.87a66.76,66.76,0,0,1,7.15-.78c2.39-.16,4.77-.2,7.16-.22s4.77.06,7.15.22a64.21,64.21,0,0,1,7.16.78,64.21,64.21,0,0,1-7.16.78c-2.38.16-4.77.2-7.15.22s-4.77-.06-7.16-.22A66.76,66.76,0,0,1,364.84,290.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,303.77c5.07-.42,10.15-.63,15.23-.78s10.16-.2,15.24-.22,10.16.06,15.24.22,10.15.36,15.23.78c-5.08.41-10.16.63-15.23.78s-10.16.2-15.24.21-10.16-.06-15.24-.22S246.4,304.18,241.33,303.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.07,303.77c3.16-.42,6.32-.63,9.48-.78s6.32-.2,9.49-.22,6.32.06,9.48.22,6.32.36,9.48.78c-3.16.41-6.32.63-9.48.78s-6.32.2-9.48.21-6.33-.06-9.49-.22S312.23,304.18,309.07,303.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.8,303.77a50.73,50.73,0,0,1,6.35-.78c2.12-.16,4.24-.2,6.35-.22s4.24.06,6.36.22a49.36,49.36,0,0,1,6.35.78,53.17,53.17,0,0,1-6.35.78c-2.12.15-4.24.2-6.36.21s-4.23-.06-6.35-.22A50.71,50.71,0,0,1,366.8,303.77Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,316.66a35.1,35.1,0,0,1,5.14-.78c1.71-.14,3.42-.22,5.14-.22s3.42.07,5.13.22a33.61,33.61,0,0,1,5.14.78,33.61,33.61,0,0,1-5.14.78c-1.71.15-3.42.23-5.13.22s-3.43-.08-5.14-.22A35.1,35.1,0,0,1,371.66,316.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.33,316.66q8.46-.59,16.93-.78c5.65-.16,11.29-.2,16.94-.22s11.29.06,16.93.22,11.29.39,16.94.78q-8.47.58-16.94.78c-5.64.16-11.29.2-16.93.22s-11.29-.06-16.94-.22S247,317.05,241.33,316.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526,235.54a38.68,38.68,0,0,1-23.54,35.57l-15.11-35.57Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.91,232.88,496,268.46s0,0-.08,0c-1.18.49-2.37.93-3.55,1.3a38.66,38.66,0,1,1,27.17-36.91Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.93,232.88l-25.18,29.29a38.63,38.63,0,1,1,63.8-29.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.3,
    y: 288.2,
    width: 5.42,
    height: 5.42,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.3,
    y: 301.16,
    width: 5.42,
    height: 5.42,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.3,
    y: 314.12,
    width: 5.42,
    height: 5.42,
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.24,289.12c3.45-.41,6.89-.63,10.33-.78s6.89-.2,10.33-.22,6.89.06,10.33.22,6.89.36,10.34.78c-3.45.42-6.89.63-10.34.78s-6.88.2-10.33.22-6.88-.06-10.33-.22S456.69,289.53,453.24,289.12Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.3,187.72c4.36-.42,8.71-.63,13.07-.78s8.71-.2,13.06-.22,8.71.06,13.07.22,8.71.36,13.07.78c-4.36.41-8.72.63-13.07.78s-8.71.2-13.07.22-8.71-.07-13.06-.23S446.66,188.13,442.3,187.72Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.3,184q9.19-.57,18.39-.77c6.13-.16,12.26-.21,18.4-.23s12.26.06,18.39.22,12.26.4,18.39.78q-9.19.58-18.39.78c-6.13.16-12.26.21-18.39.22s-12.27-.06-18.4-.22S448.43,184.35,442.3,184Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.24,292.7a60.55,60.55,0,0,1,6.92-.78c2.31-.16,4.62-.2,6.93-.22s4.61.06,6.92.22a58.15,58.15,0,0,1,6.92.78,62.61,62.61,0,0,1-6.92.78c-2.31.16-4.62.2-6.92.22s-4.62-.07-6.93-.23A60.52,60.52,0,0,1,453.24,292.7Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.24,302.08a29.79,29.79,0,0,1,4.72-.78c1.57-.14,3.14-.22,4.72-.22a46.73,46.73,0,0,1,4.72.22,28.57,28.57,0,0,1,4.71.78,28.57,28.57,0,0,1-4.71.78c-1.58.14-3.15.22-4.72.22s-3.15-.08-4.72-.22A29.79,29.79,0,0,1,453.24,302.08Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.24,305.66a76.3,76.3,0,0,1,8-.78c2.65-.16,5.3-.2,7.95-.22s5.3.06,8,.21a79.24,79.24,0,0,1,7.95.79c-2.65.41-5.3.63-7.95.78s-5.31.2-8,.21-5.3-.06-7.95-.22A79.09,79.09,0,0,1,453.24,305.66Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.24,315c2.85-.42,5.69-.63,8.54-.78s5.69-.2,8.53-.22,5.69.06,8.54.22,5.69.36,8.53.78c-2.84.41-5.69.63-8.53.78s-5.69.2-8.54.22-5.69-.07-8.53-.22S456.09,315.45,453.24,315Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.24,318.61c3.72-.41,7.44-.63,11.16-.77s7.44-.21,11.16-.23,7.43.06,11.15.22,7.44.37,11.16.78c-3.72.42-7.44.64-11.16.78s-7.43.21-11.15.22-7.44-.06-11.16-.22S457,319,453.24,318.61Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-42"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 474.03,
    cy: 452.8,
    rx: 96.83,
    ry: 9.45,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M495.14,456.69c2.11-.72,50.22-37.45,51.17-40,.37-1-4.57-8.29-10.79-17-1.35-1.87-2.75-3.8-4.18-5.74-9.28-12.66-19.42-25.88-19.42-25.88l-32.25,24.48L500,417.77l4.45,5.54s-12.13,22.3-12.87,25.22S493,457.42,495.14,456.69Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.35,387.2c1.65,2.22,3.33,4.51,5,6.77,1.44,1.95,2.84,3.87,4.18,5.74,6.22,8.68,11.16,16,10.79,17-.95,2.56-49,39.29-51.17,40s-4.31-5.24-3.58-8.16,12.87-25.22,12.87-25.22L500,417.78l-4.53-5.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.92,457.14c2.14-.74,50.9-38.33,51.86-40.94.44-1.2-7.12-11.91-15.34-23l-31.79,24.36,4.55,5.61s-12.23,22.75-13,25.72S492.77,457.89,494.92,457.14Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.11,454.65c8-6.5,41-32,49.4-37.78.07-.05.1,0,0,.05-7.81,6.62-41,31.82-49.33,37.87C494,454.92,493.94,454.79,494.11,454.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.65,422.22c2.76-3.08,7.07-5.62,11.3-5.23.16,0,.13.25,0,.3a57.35,57.35,0,0,0-11,5.32A.26.26,0,0,1,501.65,422.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.41,425.41c2.75-3.08,7.07-5.62,11.29-5.23.17,0,.14.25,0,.3a57,57,0,0,0-11,5.32A.26.26,0,0,1,500.41,425.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.17,428.59c2.75-3.08,7.06-5.61,11.29-5.22.16,0,.14.25,0,.3a57.05,57.05,0,0,0-11,5.32A.26.26,0,0,1,499.17,428.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.92,431.78c2.76-3.08,7.07-5.62,11.3-5.22.16,0,.14.25,0,.3a56.77,56.77,0,0,0-11,5.32A.26.26,0,0,1,497.92,431.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495,422.83c3.64,0,7.16-1.55,10.57-2.61a.5.5,0,0,0,.2-.79.11.11,0,0,0,0-.18,21.76,21.76,0,0,0-10.63-3.55c-2.21-.09-5.17.94-5.09,3.66C490.05,421.93,492.83,422.82,495,422.83Zm-2.81-2c-3.29-3.09,1.93-4.16,3.55-4a23.51,23.51,0,0,1,3.13.53,64.54,64.54,0,0,1,6.25,1.94c-1.7.42-3.36,1-5.05,1.46C498,421.35,494,422.58,492.14,420.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.66,406.07c-2.32-1.4-4.68.66-5.69,2.63a21.73,21.73,0,0,0-2.15,11,.11.11,0,0,0,.15.09.5.5,0,0,0,.78.22c2.61-2.44,5.7-4.73,7.48-7.91C514.27,410.26,514.86,407.4,512.66,406.07ZM509,415.51c-1.26,1.23-2.56,2.4-3.77,3.68a63.46,63.46,0,0,1,1.4-6.4,22.56,22.56,0,0,1,1.08-3c.68-1.48,4.19-5.5,5.26-1.11C513.5,411.12,510.44,414,509,415.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.08,343.5c2.17,16.47,42.76,64,47.45,69.47l1.07,1.25,33.58-25.81-.39-.5L498.22,349.2s48.9,28.53,73.37,15.58c11-5.82,19.13-16.16,19.13-16.16l-31.93-17s-8.84,2.86-14.49,2c-19.46-2.85-63.08-19.41-73.43-19C457.52,315.19,444.08,328.38,446.08,343.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.61,334.8a41.39,41.39,0,0,1,3.05,3.91c1,1.37,2.1,2.73,3.15,4.1l0,0-.56-1.2c-.66-1.37-1.19-2.78-2-4.08a.07.07,0,0,1,.13-.07c.8,1.29,1.73,2.52,2.41,3.89.32.64.63,1.29.91,1.95.16.36.32.72.46,1.09.06.16.14.34.19.52.47.64.93,1.28,1.38,1.93,1,1.44,1.87,3,2.88,4.4.06.07-.07.14-.12.07-1-1.34-2.17-2.6-3.2-3.93s-2.06-2.76-3.05-4.17-1.91-2.76-2.87-4.13a42,42,0,0,1-2.91-4.25C487.49,334.82,487.56,334.76,487.61,334.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.76,321.57l6.8,1.13a21.17,21.17,0,0,0,3.94-12.21c0-1,1.55,5-.5,12.78,7.18,1.19,18.75,3,27.29,4.33.64-3.32,1.38-6.36,1.38-6.36a37.68,37.68,0,0,0,.47,6.65l3.41.53a130.17,130.17,0,0,1,2.65-14.13,45.84,45.84,0,0,0,2.21,14.85c5.42.79,9,1.21,8.81.92-6.88-10.58-.1-15.15-1.26-23.77-1.39-10.34-9.74-13.13-8.43-20.56,1.05-6,5.36-24.61-3.46-26.51,0,0-6.13-8.28-16.46-5.9-12.78,2.93-12.11,28.82-13.48,32.51-1.94,5.28-4.8,6.83-7.62,12.76s-.59,10.58-.87,14.88S534.4,321.36,535.76,321.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.66,328.75a21.39,21.39,0,0,1-1.89-5.69,11.19,11.19,0,0,1,.83-5.7,58.09,58.09,0,0,0,1.85-5.86,16,16,0,0,0,.29-6.33,14,14,0,0,0-2.51-5.85,37.33,37.33,0,0,0-4.1-4.62,22.49,22.49,0,0,1-3.75-4.61,11,11,0,0,1-1.41-5.74,10.35,10.35,0,0,0,.75,6.07,20.82,20.82,0,0,0,3.52,5.09,47.27,47.27,0,0,1,3.77,4.64,13.34,13.34,0,0,1,2.14,5.28,15.67,15.67,0,0,1-.23,5.74c-.39,1.93-1,3.83-1.57,5.81a19.08,19.08,0,0,0-.63,3.06,9,9,0,0,0,.24,3.19A17.41,17.41,0,0,0,592.66,328.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.06,262.51a29.33,29.33,0,0,0-2.86,6.69c-.72,2.32-1.8,10-2.38,12.33l-.88,3.5a17.49,17.49,0,0,1-1.14,3.29,18.94,18.94,0,0,1-4.34,5.44,26.76,26.76,0,0,0-2.52,2.77,17.29,17.29,0,0,0-2,3.25,24.24,24.24,0,0,0-1.16,3.56,15.13,15.13,0,0,0-.44,3.74c0,1.26.16,2.48.25,3.67a17.44,17.44,0,0,1,0,3.54,7.28,7.28,0,0,1-4,5.5,7.39,7.39,0,0,0,4.78-5.36,17.68,17.68,0,0,0,.32-3.7c0-1.24-.11-2.44-.05-3.6a18.78,18.78,0,0,1,1.75-6.72,16.45,16.45,0,0,1,1.82-2.93,25.34,25.34,0,0,1,2.41-2.59,34.68,34.68,0,0,0,2.54-2.71,15,15,0,0,0,2-3.22,19,19,0,0,0,1.12-3.58c.28-1.19.51-2.38.74-3.56.47-2.38,1.38-10.06,1.91-12.41A34.1,34.1,0,0,1,554.06,262.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.65,299.81c-7,17.19-16.73,35.42-20.91,38.31-5.29,3.66-34.66,10.26-36.2,10.18-3.8-.23-9.8-27.84-5.72-27.78,6.21.1,29.06-1.5,30.6-2.65s12.79-11.45,24.5-23.18C575,286.58,579,289.14,574.65,299.81Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.15,347.15a82.91,82.91,0,0,1-11,4.18c-3,.74-11.66,2.64-12.8-.57-.79-2.19,4.18-3.9,7.66-5.2,1.84-.68,4.13-2.48,3.65-3.66-.85-2.07-5.58-.21-8.71,1.44-6,3.21-14.15,9.08-17.65,5.94-1.32-1.19.35-3.19,2.75-5.12-3.86,2.21-7.95,4-9.46,2.73a2,2,0,0,1-.34-2.71,2.62,2.62,0,0,1-2.88-.57c-1.18-1.32-.51-3.19.91-5.07a1.5,1.5,0,0,1-1.09-.78c-2.43-4.05,11-14.87,15.5-15.76a113.39,113.39,0,0,1,27.18-1.49C518.88,324.85,520.16,347.14,520.15,347.15Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.23,334.26a22.23,22.23,0,0,0-8.92,3c-3.43,2.07-5.75,4.57-8.66,7.06a.08.08,0,1,0,.1.12c1.39-1.18,7.11-5.61,8.58-6.62a21.36,21.36,0,0,1,8.91-3.55S501.27,334.25,501.23,334.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499,328.56a54.2,54.2,0,0,0-10.37,3.15c-3.59,1.66-6.46,4.47-9.28,7.18-1.69,1.63-3.35,3.29-5,5-.07.07,0,.19.1.12q4.29-4.2,8.83-8.14a28.24,28.24,0,0,1,9.56-5.51c2-.68,4.08-1.2,6.14-1.72C499,328.62,499,328.56,499,328.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.48,323.53c-3.39.56-6.35,1-9.4,2.72a48.09,48.09,0,0,0-9.4,7.49c-1.54,1.51-3,3.08-4.49,4.67-.06.07.05.17.11.11A112.12,112.12,0,0,1,483,328.75a22.42,22.42,0,0,1,5.89-3.51,39.79,39.79,0,0,1,6.63-1.69S495.5,323.52,495.48,323.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.75,317.51,523,348.43s26.32-3.71,31.64-8.06,17.43-28.93,21.67-41.07-2.12-12.7-9-5.64-23.8,22.59-24.66,22.89S517.75,317.51,517.75,317.51Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.24,335.61c-.64-3.65-1.32-7.29-1.84-11-.29-2.09-.59-4.17-.86-6.26,0-.08.12-.11.14,0,.79,3.64,1.58,7.29,2.21,11s1.29,7.3,1.87,11c.32,2.08.59,4.16.79,6.27,0,0-.06.05-.07,0C528.56,343,527.9,339.29,527.24,335.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.46,345.36l.53,3.07s26.32-3.72,31.64-8.06,17.43-28.93,21.67-41.07c3.1-8.88.54-11.57-3.76-9.61C560,303.42,536.19,329.49,522.46,345.36Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.05,356.06c-1.88.61-55.26-14.84-55.26-14.84l6.3-18.53s-3.11-6-1.67-11.7c1.94-7.66,16.11-20.25,17.23-21,4.47-3,8.66-2.91,12.37-.94C600.45,297.26,606.05,356.06,606.05,356.06Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.55,288.4a12.75,12.75,0,0,1,1.47.66,10.52,10.52,0,0,1,1.35.86,1.57,1.57,0,0,1-1.37.79,1.61,1.61,0,0,1-1.61-1.62A1.46,1.46,0,0,1,583.55,288.4Zm-11.43,2a1.59,1.59,0,0,0,.91.29,1.62,1.62,0,0,0,1.61-1.62,1.5,1.5,0,0,0,0-.22,18.38,18.38,0,0,0-2,1.13ZM595.34,305a1.61,1.61,0,0,0,.75,1.36c-.22-.62-.45-1.22-.67-1.83A1.22,1.22,0,0,0,595.34,305Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.62,1.62,0,0,0,583.38,305Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.61,1.61,0,0,0,571.42,305Zm-12,0a1.62,1.62,0,1,0,1.61-1.61A1.61,1.61,0,0,0,559.46,305Zm29.9-8a1.61,1.61,0,0,0,3,.75c-.44-.83-.88-1.62-1.35-2.36H591A1.62,1.62,0,0,0,589.36,297Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.61,1.61,0,0,0,577.4,297Zm-12,0a1.62,1.62,0,1,0,1.62-1.62,1.36,1.36,0,0,0-.29,0l-1.31,1.33A2.28,2.28,0,0,0,565.44,297Zm29.9,23.93A1.62,1.62,0,1,0,597,319.3,1.62,1.62,0,0,0,595.34,320.91Zm-12,0A1.62,1.62,0,1,0,585,319.3,1.62,1.62,0,0,0,583.38,320.91Zm-12,0A1.62,1.62,0,1,0,573,319.3,1.61,1.61,0,0,0,571.42,320.91Zm-12,0a1.62,1.62,0,1,0,1.61-1.61A1.61,1.61,0,0,0,559.46,320.91Zm29.9-8a1.62,1.62,0,1,0,3.23,0,1.62,1.62,0,0,0-3.23,0Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.62,1.62,0,0,0,577.4,312.88Zm-12,0a1.62,1.62,0,1,0,1.61-1.61A1.62,1.62,0,0,0,565.44,312.88Zm-10.39,1.62h0a1.62,1.62,0,0,0,.26-3.21A13.07,13.07,0,0,0,555.05,314.5Zm40.29,22.32a1.62,1.62,0,1,0,1.62-1.61A1.62,1.62,0,0,0,595.34,336.82Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.62,1.62,0,0,0,583.38,336.82Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.61,1.61,0,0,0,571.42,336.82Zm-12,0a1.62,1.62,0,1,0,1.61-1.61A1.61,1.61,0,0,0,559.46,336.82Zm41.87-8a1.6,1.6,0,0,0,.91,1.45c-.16-.84-.32-1.68-.5-2.52A1.57,1.57,0,0,0,601.33,328.79Zm-12,0a1.62,1.62,0,1,0,3.23,0,1.62,1.62,0,0,0-3.23,0Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.62,1.62,0,0,0,577.4,328.79Zm-12,0a1.62,1.62,0,1,0,1.61-1.61A1.62,1.62,0,0,0,565.44,328.79Zm-10.93,1.5a1.4,1.4,0,0,0,.58.12,1.62,1.62,0,0,0,.45-3.17Zm40.83,22.44a1.59,1.59,0,0,0,.39,1l1.8.47h0a1.64,1.64,0,0,0,1-1.51,1.62,1.62,0,0,0-3.23,0Zm6-8a1.62,1.62,0,1,0,1.62-1.61A1.62,1.62,0,0,0,601.32,344.7Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.62,1.62,0,0,0,589.36,344.7Zm-12,0a1.62,1.62,0,1,0,1.62-1.61A1.61,1.61,0,0,0,577.4,344.7Zm-12,0a1.5,1.5,0,0,0,.21.78c.72.2,1.45.4,2.19.62a1.59,1.59,0,0,0,.83-1.4,1.62,1.62,0,0,0-3.23,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.34,290.23c-.07,1-3.66,7.89-8.05,8.36-1.43.15-2.61-7.62-2.61-7.62l-.22-.55-3-7.76,9.73-8.53S581.37,289.81,581.34,290.23Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.42,282.66l3.05,7.76a16.77,16.77,0,0,0,8.11-10.93l-1.41-5.31a.18.18,0,0,1,0-.05l-1.25,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.87,272.15c-.25,14.62,8.48,16.42,11.63,16.47,2.86,0,12.61-.16,14.37-14.68s-5-19.25-11.49-19.7S554.12,257.53,553.87,272.15Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.12,269.81c.34-.06.64-.17,1-.26a1.63,1.63,0,0,0,.94-.45.54.54,0,0,0,0-.64,1.3,1.3,0,0,0-1.29-.23,1.88,1.88,0,0,0-1.15.73A.55.55,0,0,0,556.12,269.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.08,270.52c-.35,0-.66-.1-1-.16a1.68,1.68,0,0,1-1-.35.54.54,0,0,1,0-.64,1.3,1.3,0,0,1,1.25-.37,2,2,0,0,1,1.23.61A.56.56,0,0,1,566.08,270.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.12,272.81s.08.05.08.09c0,1,.17,2.13,1.08,2.44,0,0,0,.06,0,.05C564.17,275.27,564,273.75,564.12,272.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565,271.75c1.6-.17,1.82,3,.34,3.19S563.64,271.89,565,271.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.62,271.87c.3.16.59.47.93.48s.67-.35.9-.69c0,0,0,0,.06,0,0,.62-.14,1.26-.8,1.4s-1.06-.39-1.26-1C565.42,272,565.51,271.81,565.62,271.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.35,272.88s-.07.05-.07.09c.11,1,.06,2.14-.81,2.54,0,0,0,.06,0,.05C558.57,275.33,558.61,273.8,558.35,272.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.39,271.91c-1.61,0-1.49,3.21,0,3.21S558.73,271.91,557.39,271.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.72,272.14c-.24.18-.48.5-.79.53s-.62-.3-.86-.62c0,0,0,0,0,0,0,.62.23,1.25.82,1.34s.92-.45,1-1.07C556.92,272.24,556.82,272.07,556.72,272.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.86,281.59c-.21.27-.4.62-.75.7a2.58,2.58,0,0,1-1.1-.1s-.06,0,0,.06a1.36,1.36,0,0,0,1.33.36,1.07,1.07,0,0,0,.65-1C565,281.57,564.89,281.56,564.86,281.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.3,278.06s-.08,1.49,0,2.19c0,.07.18.09.42.08h0a3.34,3.34,0,0,0,3.12-1.52c0-.07-.06-.13-.12-.09a5,5,0,0,1-3,1.13c-.07-.19.22-2.56.1-2.56a6.13,6.13,0,0,0-1.55.49c.07-3.12.65-6.21.67-9.33a.09.09,0,0,0-.18,0,50.72,50.72,0,0,0-1.16,10C558.64,278.85,560,278.2,560.3,278.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.71,280.05a4.11,4.11,0,0,0,1.62,1.29,1.81,1.81,0,0,0,1.11.08c.81-.2.84-.94.7-1.58a4.16,4.16,0,0,0-.35-1A5.26,5.26,0,0,1,560.71,280.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.33,281.34a1.81,1.81,0,0,0,1.11.08c.81-.2.84-.94.7-1.58A1.89,1.89,0,0,0,562.33,281.34Z",
    style: {
      fill: "#ff99ba"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.92,274.74a6,6,0,0,1-4-4.44,15.66,15.66,0,0,1-7-4.29c.14.29,1.12,2.36,1.66,3.4-9.45-.51-13.23-7.19-13.23-7.19a16,16,0,0,0-3.25,6.38s-.81-5.65,1.59-9.82a9.21,9.21,0,0,1,7.93-4.87,13.13,13.13,0,0,1,13.24,2.24C583.67,261.89,579.92,274.74,579.92,274.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.33,268.81a17.39,17.39,0,0,0,5,1.11s0,0,0,0a14.6,14.6,0,0,1-7.31-3.2,13.37,13.37,0,0,1-2.35-2.52,9.55,9.55,0,0,1-1.69-3.35.07.07,0,0,0-.14,0A11.09,11.09,0,0,0,558,264.4a10,10,0,0,0,2.45,2.78,11.63,11.63,0,0,0,2.87,1.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.53,275s2.87-4.78,5-3.78.21,7.75-2.15,8.82A2.47,2.47,0,0,1,577,279Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.94,273.17s0,.05,0,.06a6.29,6.29,0,0,0-3,4.13,1.36,1.36,0,0,1,2-.52s0,.11,0,.1a1.52,1.52,0,0,0-1.63.64,7.41,7.41,0,0,0-.7,1.41c-.07.16-.35.1-.31-.08v0C578.15,276.7,579.62,273.55,581.94,273.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.07,292.08c11.27,8.67,41,43.74,34.78,52.06s-48.79,5.55-61.21,2c-3.69-1.07,5.79-24.58,9.73-25.74,3.28-1,21.72,4,22,3s-3.71-9-10.29-23.18C576.53,283.77,584.09,288.25,589.07,292.08Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.21,316.29c-8.51.22-10.67,1.58-18-2.05-4.78-2.38-8.36-.35-5.11,4.15,5.31,7.38,16.36,9.4,20.39,9Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.65,320.65s-10.21-3.65-19.31-4.31c-6.29-.46-20.09.06-30.82,15.54-2.54,3.67-3.57,10.71,2.77,6.22,4.49-3.19,6.38-6.57,9.34-8,0,0-.24,9.11,3.54,11.51a81.47,81.47,0,0,0,10.32,5.58,16.27,16.27,0,0,0,1.21-1.83s3.75,1.91,9.92.28Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.26,316.86c-2.64,2-8.17,6.29-11.47,11.38-3.67,5.66-9.2,17.55-5,20.22,3.09,2,5.6-2.4,5.6-2.4s-1.25,5.39,1.92,6.55c2.89,1.05,4.63-2.44,4.63-2.44s-.19,3.41,2.79,3.89c3.58.57,3.4-6.66,7.53-9.22C559.19,344.27,552.26,316.86,552.26,316.86Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.42,331.12a26.86,26.86,0,0,0-6.1,14.81c0,.14.1.22.13.09a66,66,0,0,1,6-14.87S547.44,331.09,547.42,331.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553,335c-1.68,2.15-5.11,9-5.19,15.15,0,.13.1.21.13.08a70.53,70.53,0,0,1,5.12-15.2A0,0,0,0,0,553,335Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.62,330.1c-2.58,1.25-4.13,2.87-6.15,4.84a41.3,41.3,0,0,1-3.13,2.79c-1,.78-2.49,1.95-3.82,1.21a2.26,2.26,0,0,1-.87-2.13,11.1,11.1,0,0,1,1-3.33s0-.08-.07,0a15.85,15.85,0,0,0-1.17,3,3.62,3.62,0,0,0,.1,2.16c.65,1.43,2.45,1.33,3.63.71a12.14,12.14,0,0,0,2-1.38c.6-.49,1.17-1,1.73-1.53,1.14-1.09,2.22-2.24,3.36-3.33a34.84,34.84,0,0,1,3.5-2.91C539.72,330.15,539.67,330.07,539.62,330.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.52,340.58a86.42,86.42,0,0,1,4.16-10.43s0-.08-.06,0a44.85,44.85,0,0,0-4.81,10.08,15.15,15.15,0,0,0-.74,6c.47,2.83,2.44,3.06,3.16,3.08a3.7,3.7,0,0,0,2.34-.79,7.44,7.44,0,0,0,1.85-2.42s0-.09-.06,0c-.8,1.27-2.25,2.65-3.82,2.7a2.6,2.6,0,0,1-1.91-.66,3.4,3.4,0,0,1-.84-2.2A15.79,15.79,0,0,1,535.52,340.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.65,320.65l-8.55,29.77s53.23,3,56.18-6.63-22.77-41.33-33.43-50c-12.37-10.08-13-5.85-9,4.23,4.22,10.56,11.47,25.63,11.47,25.63Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.13,328.39a61,61,0,0,0-8.21-3.16,59.06,59.06,0,0,0-8.49-1.88c-1.64-.26-3.28-.43-4.93-.62a0,0,0,0,0,0,.08,73.11,73.11,0,0,1,8.56,1.8c2.81.73,5.59,1.51,8.37,2.34,1.57.48,3.11,1,4.67,1.55A.06.06,0,0,0,611.13,328.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.78,320.54c.27,0,15.07,2.34,15.56,2.48-.09-.2-3.84-7.25-4.4-8.28-.06-.1-.11-.21-.16-.31-.34-.44-.68-.89-1-1.35l-1.21-1.76s0,0,0,0c.43.57.87,1.14,1.29,1.72.2.26.39.53.58.8-.38-.73-.74-1.46-1.11-2.2-.58-1.18-1.12-2.37-1.67-3.57,0,0,.05-.06.06,0,1.11,2.05,2.28,4.07,3.39,6.12s5.32,9.58,5.3,9.58-16.36-2.9-16.68-3A.11.11,0,0,1,577.78,320.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.81,338.71c.93-3.32,1.84-6.65,2.9-9.94.6-1.86,1.19-3.73,1.81-5.59,0-.07.15,0,.13,0-.81,3.37-1.62,6.74-2.58,10.08s-1.89,6.63-2.88,9.94c-.57,1.88-1.19,3.73-1.87,5.57,0,0-.08,0-.07,0C577.94,345.39,578.87,342.05,579.81,338.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.51,351c.37-.93.82-2.26,1.23-3.18.11-.24.28-.23.21,0-.27.84-.45,1.76-.7,2.61l2.23.07,2.58.11c1.69.07,3.38.12,5.06.15q5.13.09,10.25,0a197.72,197.72,0,0,0,20.5-1.44c1.91-.25,3.8-.53,5.69-.87a52.74,52.74,0,0,0,5.54-1.19s.07.07,0,.09a31.65,31.65,0,0,1-4.75,1.43c-1.7.37-3.4.69-5.12,1-3.42.52-6.86.86-10.31,1.11q-10.26.75-20.56.63c-1.92,0-3.84-.07-5.76-.13l-2.91-.12A18,18,0,0,1,568.51,351Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 494.64,
    y: 352.22,
    width: 62.86,
    height: 2.82,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "494.64 352.22 494.64 355.03 537.37 355.03 535.21 352.22 494.64 352.22",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.5 355.03 471.24 355.03 466.14 313.43 527.4 313.43 532.5 355.03",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.05,334.23a3.66,3.66,0,0,1-3.67,3.73,3.81,3.81,0,0,1-3.79-3.73,3.65,3.65,0,0,1,3.66-3.73A3.82,3.82,0,0,1,503.05,334.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.4,412.87c.78,2.09,38.72,49.25,41.3,50.14,1,.34,8.17-4.79,16.69-11.23,1.84-1.39,3.73-2.84,5.64-4.32,12.42-9.59,25.37-20.07,25.37-20.07l-25.29-31.62-24.68,20.94L406,421.3s-22.6-11.56-25.54-12.22S371.63,410.77,372.4,412.87Z",
    style: {
      fill: "#dd6a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.66,442.3,436,447.46q-2.88,2.24-5.64,4.32c-8.52,6.44-15.71,11.56-16.69,11.22-2.58-.88-40.52-48-41.3-50.14s5.14-4.44,8.07-3.79S406,421.3,406,421.3l5.42-4.59,5.51-4.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,412.65c.79,2.12,39.61,49.92,42.24,50.8,1.21.41,11.72-7.41,22.63-15.91l-25.16-31.16-5.49,4.69s-23-11.65-26-12.31S371.15,410.53,372,412.65Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.42,411.78c6.7,7.85,33,40.16,39,48.43.05.07,0,.1-.05,0-6.81-7.64-32.84-40.15-39.11-48.36C374.15,411.72,374.27,411.62,374.42,411.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,418.5c3.15,2.67,5.8,6.92,5.51,11.16,0,.16-.24.14-.3,0a57.33,57.33,0,0,0-5.59-10.84A.25.25,0,0,1,407,418.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.81,417.34c3.15,2.67,5.8,6.92,5.51,11.15,0,.17-.24.15-.3,0a57,57,0,0,0-5.59-10.84A.25.25,0,0,1,403.81,417.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.59,416.17c3.15,2.68,5.8,6.93,5.51,11.16,0,.17-.24.15-.29,0a57.65,57.65,0,0,0-5.6-10.84A.26.26,0,0,1,400.59,416.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.38,415c3.14,2.68,5.79,6.93,5.5,11.16,0,.16-.24.14-.29,0a57.35,57.35,0,0,0-5.6-10.84A.26.26,0,0,1,397.38,415Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.25,411.81c.08,3.64,1.73,7.12,2.88,10.51a.5.5,0,0,0,.79.17c.06,0,.13.06.18,0a21.7,21.7,0,0,0,3.28-10.72c0-2.21-1.07-5.14-3.78-5S406.21,409.69,406.25,411.81Zm1.89-2.86c3-3.36,4.21,1.82,4.11,3.46a22.26,22.26,0,0,1-.45,3.13c-.42,2.16-1.14,4.21-1.77,6.31-.47-1.7-1.07-3.35-1.6-5C407.81,414.82,406.48,410.81,408.14,409Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.45,429.1c1.35-2.36-.78-4.66-2.77-5.62a21.72,21.72,0,0,0-11.06-1.88.11.11,0,0,0-.09.15.5.5,0,0,0-.2.79c2.51,2.54,4.88,5.58,8.1,7.28C419.31,430.81,422.18,431.33,423.45,429.1Zm-9.52-3.48c-1.27-1.22-2.47-2.5-3.78-3.67a63.4,63.4,0,0,1,6.43,1.23,22.63,22.63,0,0,1,3,1c1.5.65,5.6,4,1.24,5.22C418.43,430.07,415.44,427.08,413.93,425.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.75,411.94l26.32,35.51,88.81-61.63,8.57-5.94s2.42,1.63,6.07,3.65c5.07,2.8,12.5,6.35,19.07,7.32,11,1.63,29.44,1.45,38.73-11,7.83-10.47,3.58-24.12,3.58-24.12l-12.11-5.2s-28.65-23.87-47.2-24.58c-7.89-.32-19.36,5.66-30,11.9S412.75,411.94,412.75,411.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.45,379.88s2.42,1.63,6.07,3.65c6.45-7.73,20.12-21.76,20.53-22.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.29,342.57c1.72,1.19,3.37,2.46,5.06,3.68s3.38,2.32,5,3.64,3.13,2.75,4.64,4.19c.73.69,1.46,1.39,2.16,2.11a19,19,0,0,1,2.06,2.24c.06.07,0,.16-.12.12a25.72,25.72,0,0,1-2.3-1.87c-.8-.67-1.59-1.36-2.39-2-1.54-1.31-3.11-2.58-4.64-3.89s-3-2.73-4.46-4.05-3.32-2.73-5-4.07C581.23,342.6,581.26,342.55,581.29,342.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.93,410.66c1.71,1.85,3.29,3.83,4.89,5.78s3.18,3.91,4.76,5.88c3.16,3.95,6.34,7.87,9.44,11.86,1.71,2.19,3.39,4.39,5,6.67.07.1-.09.22-.17.13-3.4-3.74-6.5-7.72-9.65-11.66s-6.3-7.9-9.4-11.9c-1.69-2.18-3.44-4.36-5-6.64C418.71,410.69,418.86,410.58,418.93,410.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.82,411c4.42-3.49,9-6.77,13.58-10s9.11-6.51,13.74-9.66c1.33-.91,2.67-1.79,4-2.68s2.72-1.71,4-2.63a.07.07,0,1,1,.07.12c-1.2.87-2.34,1.83-3.52,2.73s-2.24,1.71-3.38,2.56c-2.22,1.64-4.46,3.25-6.7,4.87-4.53,3.28-9.11,6.52-13.72,9.68-2.62,1.8-5.23,3.61-7.91,5.32C491.86,411.4,491.67,411.15,491.82,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.42,374.39c4.08-3.39,8.46-6.43,12.74-9.56s8.63-6.36,13-9.5L502.07,346c4.18-3,8.34-6.09,12.76-8.77,2.41-1.46,4.89-2.82,7.44-4A48.47,48.47,0,0,1,530,330a.07.07,0,0,1,0,.13c-2.18,1.22-4.46,2.24-6.66,3.41s-4.33,2.38-6.43,3.66c-4.39,2.66-8.52,5.67-12.68,8.66-8.63,6.21-17.25,12.45-25.94,18.57-4.87,3.43-9.64,7-14.69,10.19C463.45,374.75,463.27,374.51,463.42,374.39Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaiting);
export default __webpack_public_path__ + "static/media/waiting.6f41d25fa72f82bd4e56f563b72d6e2f.svg";
export { ForwardRef as ReactComponent };